/* ============================================================
   UNVEXT — Main JavaScript
   Vanilla JS — zero dependencies
   ============================================================ */

(function () {
  'use strict';


  /* Promotional popup */
  const promoPopup = document.getElementById('promo-popup');
  if (promoPopup && promoPopup.dataset) {
    const promoFrequency = promoPopup.dataset.frequency || 'once_per_day';
    const promoTrigger = promoPopup.dataset.trigger || 'delay';
    const promoDelay = parseInt(promoPopup.dataset.delay || '5', 10);
    const promoScrollPct = parseInt(promoPopup.dataset.scrollThreshold || '30', 10);
    const PROMO_KEY = promoPopup.dataset.storageKey || 'unvext_promo_popup';

    function promoShouldShow() {
      if (sessionStorage.getItem(PROMO_KEY)) return false;
      let stored = {};
      try { stored = JSON.parse(localStorage.getItem(PROMO_KEY) || '{}'); } catch (e) {}
      if (stored.dismissedUntil && stored.dismissedUntil > Date.now()) return false;
      return true;
    }

    function promoRecordDismissal() {
      const now = Date.now();
      switch (promoFrequency) {
        case 'every_visit':
          return;
        case 'once_per_session':
          sessionStorage.setItem(PROMO_KEY, '1');
          return;
        case 'once_per_day':
          localStorage.setItem(PROMO_KEY, JSON.stringify({ dismissedAt: now, dismissedUntil: now + 86400000 }));
          return;
        case 'once_per_week':
          localStorage.setItem(PROMO_KEY, JSON.stringify({ dismissedAt: now, dismissedUntil: now + 604800000 }));
          return;
        case 'once_per_month':
          localStorage.setItem(PROMO_KEY, JSON.stringify({ dismissedAt: now, dismissedUntil: now + 2592000000 }));
          return;
        case 'once_ever':
          localStorage.setItem(PROMO_KEY, JSON.stringify({ dismissedAt: now, dismissedUntil: Number.MAX_SAFE_INTEGER }));
          return;
      }
    }

    function promoOpen() {
      if (promoPopup.open) return;
      if (typeof promoPopup.showModal === 'function') {
        promoPopup.showModal();
      } else {
        promoPopup.setAttribute('open', '');
      }
    }

    function promoClose() {
      promoRecordDismissal();
      if (typeof promoPopup.close === 'function') {
        promoPopup.close();
      } else {
        promoPopup.removeAttribute('open');
      }
    }

    promoPopup.querySelectorAll('[data-promo-close]').forEach(function (btn) {
      btn.addEventListener('click', promoClose);
    });
    promoPopup.addEventListener('cancel', promoRecordDismissal);

    promoPopup.addEventListener('click', function (e) {
      const rect = promoPopup.getBoundingClientRect();
      const inside =
        e.clientX >= rect.left &&
        e.clientX <= rect.right &&
        e.clientY >= rect.top &&
        e.clientY <= rect.bottom;
      if (!inside) promoClose();
    });

    // After a newsletter form submit the page reloads — force the popup
    // open so the visitor sees the success / error message.
    const promoFormResult = promoPopup.querySelector('[data-promo-form-result]');

    if (promoFormResult) {
      promoOpen();
      if (promoFormResult.getAttribute('data-promo-form-result') === 'success') {
        // They subscribed — don't nag them with the popup again.
        promoRecordDismissal();
      }
    } else if (promoShouldShow()) {
      if (promoTrigger === 'immediate') {
        promoOpen();
      } else if (promoTrigger === 'delay') {
        setTimeout(promoOpen, promoDelay * 1000);
      } else if (promoTrigger === 'scroll') {
        const onPromoScroll = function () {
          const max = document.documentElement.scrollHeight - window.innerHeight;
          if (max <= 0) return;
          const scrolled = (window.scrollY / max) * 100;
          if (scrolled >= promoScrollPct) {
            window.removeEventListener('scroll', onPromoScroll);
            promoOpen();
          }
        };
        window.addEventListener('scroll', onPromoScroll, { passive: true });
      } else if (promoTrigger === 'exit_intent') {
        let promoArmed = false;
        setTimeout(function () { promoArmed = true; }, 3000);
        document.addEventListener('mouseleave', function (e) {
          if (promoArmed && e.clientY <= 0 && !promoPopup.open) promoOpen();
        });
      }
    }
  }

  /* Menu system */
  const menuOverlay  = document.querySelector('.menu-overlay');
  const menuTriggers = document.querySelectorAll('.header__menu-trigger, .header__hamburger');
  const menuClose    = document.querySelector('.menu-overlay__close');
  const menuLinks    = document.querySelectorAll('.menu-overlay a');

  function openMenu() {
    if (!menuOverlay) return;
    menuOverlay.classList.add('is-open');
    document.body.classList.add('menu-open');
    menuOverlay.setAttribute('aria-hidden', 'false');
    const firstFocusable = menuOverlay.querySelector('button, a');
    if (firstFocusable) firstFocusable.focus({ preventScroll: true });
  }

  function closeMenu() {
    if (!menuOverlay) return;
    menuOverlay.classList.remove('is-open');
    document.body.classList.remove('menu-open');
    menuOverlay.setAttribute('aria-hidden', 'true');
  }

  menuTriggers.forEach(function (trigger) {
    trigger.addEventListener('click', openMenu);
  });

  if (menuClose) {
    menuClose.addEventListener('click', closeMenu);
  }

  menuLinks.forEach(function (link) {
    link.addEventListener('click', closeMenu);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMenu();
  });

  /* Menu sub-folder accordion */
  const folderTriggers = document.querySelectorAll('.menu-nav__folder-trigger');
  folderTriggers.forEach(function (btn) {
    btn.addEventListener('click', function () {
      const item = btn.closest('.menu-nav__item');
      const isOpen = item.classList.contains('is-open');
      document.querySelectorAll('.menu-nav__item.is-open').forEach(function (el) {
        el.classList.remove('is-open');
        const t = el.querySelector('.menu-nav__folder-trigger');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* Scroll reveal animations */
  const revealEls = document.querySelectorAll('.reveal');

  function stripRevealDelays(el) {
    // After the entrance settles, remove delay classes so transition-delay
    // doesn't leak into hover transitions on the same element.
    setTimeout(function () {
      el.classList.remove(
        'reveal-delay-1', 'reveal-delay-2', 'reveal-delay-3', 'reveal-delay-4',
        'reveal-delay-5', 'reveal-delay-6', 'reveal-delay-7', 'reveal-delay-8'
      );
    }, 1000);
  }

  if (revealEls.length > 0 && 'IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            stripRevealDelays(entry.target);
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    revealEls.forEach(function (el) { revealObserver.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* Sticky ATC bar — appears once buy block is out of view */
  const buyEl = document.querySelector('.pdp-buy');
  const stickyBar = document.querySelector('.sticky-atc');

  if (buyEl && stickyBar && 'IntersectionObserver' in window) {
    const atcObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      { threshold: 0.1 }
    );
    atcObserver.observe(buyEl);
  }

  /* Sticky ATC button — scroll to buy block or submit form */
  const stickyBtn = stickyBar ? stickyBar.querySelector('.sticky-atc__btn') : null;
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function () {
      const targetSel = stickyBtn.getAttribute('data-target') || '#buy';
      const target = document.querySelector(targetSel);
      const buyInView = target && target.getBoundingClientRect().top < window.innerHeight && target.getBoundingClientRect().bottom > 0;
      if (target && !buyInView) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        const form = document.getElementById('product-form');
        if (form) {
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else {
            form.submit();
          }
        }
      }
    });
  }

  /* Product filter (PLP) */
  const filterPills   = document.querySelectorAll('.filter-pill');
  const productCards  = document.querySelectorAll('.product-card[data-category]');
  const productCountEl = document.querySelector('.plp-header__count');

  filterPills.forEach(function (pill) {
    pill.addEventListener('click', function () {
      const filter = pill.getAttribute('data-filter');

      filterPills.forEach(function (p) {
        p.classList.remove('is-active');
        p.setAttribute('aria-pressed', 'false');
      });
      pill.classList.add('is-active');
      pill.setAttribute('aria-pressed', 'true');

      let visibleCount = 0;
      productCards.forEach(function (card) {
        const category = card.getAttribute('data-category');
        const show = filter === 'all' || (category && category.indexOf(filter) !== -1);
        card.classList.toggle('is-hidden', !show);
        if (show) visibleCount++;
      });

      if (productCountEl) {
        productCountEl.textContent = visibleCount + ' Product' + (visibleCount !== 1 ? 's' : '');
      }
    });
  });

  /* FAQ accordions */
  const faqItems = document.querySelectorAll('.faq-item');
  faqItems.forEach(function (item) {
    const trigger = item.querySelector('.faq-trigger');
    if (!trigger) return;
    trigger.addEventListener('click', function () {
      const isOpen = item.classList.contains('is-open');
      faqItems.forEach(function (fi) {
        fi.classList.remove('is-open');
        const t = fi.querySelector('.faq-trigger');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* PDP accordions */
  const accordionItems = document.querySelectorAll('.accordion__item');
  accordionItems.forEach(function (item) {
    const trigger = item.querySelector('.accordion__trigger');
    if (!trigger) return;
    trigger.addEventListener('click', function () {
      const isOpen = item.classList.contains('is-open');
      item.classList.toggle('is-open', !isOpen);
      trigger.setAttribute('aria-expanded', String(!isOpen));
    });
  });

  /* Multi-option variant selector (PDP) — handles Size, Color, generic combined */
  const buySection = document.querySelector('.pdp-buy');
  if (buySection) {
    const variantDataEl = buySection.querySelector('[data-variant-data]');
    let variantData = [];
    if (variantDataEl) {
      try {
        variantData = JSON.parse(variantDataEl.textContent);
      } catch (err) {
        variantData = [];
      }
    }

    const variantInput = document.querySelector('input[name="id"]');
    const atcBtn = document.querySelector('.pdp-atc-btn');
    // A waitlist product renders Join Waitlist in the ATC slot, with the same
    // .pdp-atc-btn class. Every variant is sold out by definition, so stock must
    // neither grey the size chips nor rewrite that button into "Sold Out" — the
    // size picked here is the one the customer asks to be notified about.
    const waitlistMode = !!(atcBtn && atcBtn.hasAttribute('data-unvxt-wl-join'));
    const priceEl = document.querySelector('[data-pdp-price]');
    const stickyPriceEl = document.querySelector('.sticky-atc__price');
    const optionRows = buySection.querySelectorAll('.pdp-buy__option-row');

    // Initial selected options derived from currently-selected buttons / swatches
    const selected = [];
    optionRows.forEach(function (row) {
      const idx = parseInt(row.getAttribute('data-option-index'), 10);
      const current = row.querySelector('.is-selected');
      if (current) {
        selected[idx] = current.getAttribute('data-option-value');
      }
    });

    function findVariant() {
      return variantData.find(function (v) {
        if (!v.options || v.options.length !== selected.length) return false;
        for (let i = 0; i < selected.length; i++) {
          if (selected[i] == null) return false;
          if (String(v.options[i]).toLowerCase().trim() !==
              String(selected[i]).toLowerCase().trim()) {
            return false;
          }
        }
        return true;
      });
    }

    function recomputeAvailability() {
      optionRows.forEach(function (row) {
        const idx = parseInt(row.getAttribute('data-option-index'), 10);
        const isSizingRow = row.hasAttribute('data-sizing-row');
        const valEls = row.querySelectorAll('[data-option-value]');
        valEls.forEach(function (el) {
          const candidateValue = el.getAttribute('data-option-value');
          // Build a hypothetical selection: keep all OTHER options as currently selected,
          // set this index's value to candidate. If any variant matches and is available,
          // mark this element as available.
          //
          // The Sizing row is the exception, and it has to be. Judged against the
          // current size it would disable itself: with Youth/XXXL selected there is
          // no Adult XXXL, so "Adult" went sold-out and hidden — removing the only
          // control that switches back, and stranding the shopper in the youth run.
          // A run is offered if ANY size in it can be bought; picking it then snaps
          // the size to one that exists.
          // Wildcards must be a same-LENGTH array, not an empty one: the matcher
          // rejects on `v.options.length !== trial.length` before it ever reaches
          // the null-means-any check, so [] disables every run instead of none.
          const trial = isSizingRow
            ? new Array(selected.length).fill(null)
            : selected.slice();
          trial[idx] = candidateValue;
          const match = variantData.find(function (v) {
            if (!v.options || v.options.length !== trial.length) return false;
            for (let i = 0; i < trial.length; i++) {
              if (trial[i] == null) continue; // unselected — treat as wildcard
              if (String(v.options[i]).toLowerCase().trim() !==
                  String(trial[i]).toLowerCase().trim()) {
                return false;
              }
            }
            return waitlistMode || v.available;
          });
          el.classList.toggle('is-sold-out', !match);

          /* "Sold out" and "does not exist" are different claims. On a two-option
             product (Sizing x Size) most combinations are simply not made — there
             is no Adult XXS — and greying those out reads as "temporarily out of
             stock", which invites a customer to wait for something that will never
             arrive. Hide them instead. Single-option products are unaffected:
             every value exists, so nothing is ever marked absent. */
          const exists = variantData.some(function (v) {
            if (!v.options || v.options.length !== trial.length) return false;
            for (let i = 0; i < trial.length; i++) {
              if (trial[i] == null) continue;
              if (String(v.options[i]).toLowerCase().trim() !==
                  String(trial[i]).toLowerCase().trim()) {
                return false;
              }
            }
            return true;
          });
          el.classList.toggle('is-absent', !exists);
        });
      });
    }

    /* The size chart has to follow the Sizing selection. A youth chart shown
       beside an adult size run is worse than no chart — the numbers look
       authoritative and are for a different garment. */
    function syncSizeChart() {
      const sizingRow = buySection.querySelector('[data-sizing-row]');
      const charts = document.querySelectorAll('[data-chart-sizing]');
      if (!sizingRow || !charts.length) return;
      const idx = parseInt(sizingRow.getAttribute('data-option-index'), 10);
      const current = (selected[idx] || '').toLowerCase().trim();
      if (!current) return;
      charts.forEach(function (c) {
        c.hidden = c.getAttribute('data-chart-sizing').toLowerCase().trim() !== current;
      });
      /* Announce the run so anything else keyed to it can follow — today the
         Complete the Set module, which otherwise keeps quoting the run the page
         loaded with. One event beats each consumer polling the DOM. */
      document.dispatchEvent(new CustomEvent('unvxt:run-change', {
        detail: { run: selected[idx] }
      }));
      document.querySelectorAll('[data-chart-tab]').forEach(function (t) {
        const on = t.getAttribute('data-chart-tab').toLowerCase().trim() === current;
        t.classList.toggle('is-selected', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    function updateUI() {
      const variant = findVariant();
      if (!variant) return;

      if (variantInput) variantInput.value = variant.id;

      // Price
      if (priceEl) {
        priceEl.textContent = variant.price;
        priceEl.setAttribute('content', (variant.raw_price / 100).toFixed(2));
      }
      if (stickyPriceEl) stickyPriceEl.textContent = variant.price;

      // ATC button
      if (atcBtn && !waitlistMode) {
        const defaultLabel = atcBtn.getAttribute('data-atc-default') || 'Add to Cart';
        const soldOutLabel = atcBtn.getAttribute('data-atc-sold-out') || 'Sold Out';
        if (variant.available) {
          atcBtn.textContent = defaultLabel + ' — ' + variant.price;
          atcBtn.disabled = false;
          atcBtn.classList.remove('is-disabled');
          atcBtn.removeAttribute('aria-disabled');
          atcBtn.setAttribute('aria-label', 'Add to cart');
        } else {
          atcBtn.textContent = soldOutLabel;
          atcBtn.disabled = true;
          atcBtn.classList.add('is-disabled');
          atcBtn.setAttribute('aria-disabled', 'true');
          atcBtn.setAttribute('aria-label', soldOutLabel + ' — not available');
        }
      }

      // Selected value display
      optionRows.forEach(function (row) {
        const idx = parseInt(row.getAttribute('data-option-index'), 10);
        const labelEl = row.querySelector('[data-selected-for="' + idx + '"]');
        if (labelEl && selected[idx] != null) labelEl.textContent = selected[idx];
      });
    }

    // Bind clicks on all interactive option buttons / swatches
    const optionInteractives = buySection.querySelectorAll('button.size-btn[data-option-value], button.color-swatch[data-option-value]');
    optionInteractives.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (btn.classList.contains('is-sold-out') || btn.disabled) {
          e.preventDefault();
          e.stopPropagation();
          return;
        }
        const idx = parseInt(btn.getAttribute('data-option-index'), 10);
        const value = btn.getAttribute('data-option-value');
        if (isNaN(idx) || !value) return;

        selected[idx] = value;

        // Mark selected within this option row (clear siblings, set this)
        const row = btn.closest('.pdp-buy__option-row');
        if (row) {
          row.querySelectorAll('.is-selected').forEach(function (b) {
            b.classList.remove('is-selected');
          });
          btn.classList.add('is-selected');
        }

        /* Switching Sizing can strand the selection: Youth XXS has no Adult
           counterpart, so the pair (Adult, XXS) matches no variant and updateUI()
           would bail early, leaving a stale price on a live Pre-Order button.
           Snap to the first size that actually exists in the newly chosen run. */
        if (!findVariant()) {
          optionRows.forEach(function (r) {
            const rIdx = parseInt(r.getAttribute('data-option-index'), 10);
            if (rIdx === idx) return;
            const fallback = [...r.querySelectorAll('button.size-btn[data-option-value]')].find(function (b) {
              const trial = selected.slice();
              trial[rIdx] = b.getAttribute('data-option-value');
              return variantData.some(function (v) {
                if (!v.options || v.options.length !== trial.length) return false;
                for (let i = 0; i < trial.length; i++) {
                  if (trial[i] == null) continue;
                  if (String(v.options[i]).toLowerCase().trim() !==
                      String(trial[i]).toLowerCase().trim()) return false;
                }
                return v.available;
              });
            });
            if (!fallback) return;
            selected[rIdx] = fallback.getAttribute('data-option-value');
            r.querySelectorAll('.is-selected').forEach(function (b) { b.classList.remove('is-selected'); });
            fallback.classList.add('is-selected');
          });
        }

        updateUI();
        recomputeAvailability();
        syncSizeChart();
      });
    });

    /* The drawer's own Adult/Youth tabs drive the same selection, so opening the
       chart and switching there also switches the size run behind it. One state,
       two places to change it. */
    document.querySelectorAll('[data-chart-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        const want = tab.getAttribute('data-chart-tab');
        const sizingRow = buySection.querySelector('[data-sizing-row]');
        if (!sizingRow) return;
        const match = [...sizingRow.querySelectorAll('button.size-btn[data-option-value]')]
          .find(function (b) {
            return b.getAttribute('data-option-value').toLowerCase().trim() === want.toLowerCase().trim();
          });
        if (match) match.click(); else syncSizeChart();
      });
    });

    // Initial availability pass (in case some sold-out states need adjusting at load)
    recomputeAvailability();
    syncSizeChart();
  }

  /* PDP gallery scroll indicator — the custom bar beside the stacked images.
     Purely an enhancement over the column's own scrolling: the native scrollbar
     is only hidden at the width where this renders, the gallery stays focusable
     and arrow-key scrollable, and if this never initialises the column still
     scrolls normally. */
  (function () {
    const nav = document.querySelector('[data-gallery-nav]');
    const scroller = document.querySelector('.pdp-main__media');
    if (!nav || !scroller) return;

    const track = nav.querySelector('[data-gallery-track]');
    const thumb = nav.querySelector('[data-gallery-thumb]');
    const steps = nav.querySelectorAll('[data-gallery-step]');
    if (!track || !thumb) return;

    let dragging = false;

    function slideHeight() {
      const slide = scroller.querySelector('.pdp-hero__slide');
      return slide ? slide.getBoundingClientRect().height : scroller.clientHeight * 0.8;
    }

    function render() {
      const range = scroller.scrollHeight - scroller.clientHeight;
      /* The nav only earns its place when there is something to scroll. A
         two-image product on a tall screen may not overflow at all. */
      if (range <= 1) {
        nav.classList.remove('is-ready');
        return;
      }
      nav.classList.add('is-ready');

      const trackH = track.clientHeight;
      const ratio = scroller.clientHeight / scroller.scrollHeight;
      const thumbH = Math.max(24, Math.round(trackH * ratio));
      const progress = scroller.scrollTop / range;
      thumb.style.height = thumbH + 'px';
      thumb.style.top = Math.round(progress * (trackH - thumbH)) + 'px';

      steps.forEach(function (btn) {
        const dir = parseInt(btn.getAttribute('data-gallery-step'), 10);
        const atEnd = dir < 0 ? scroller.scrollTop <= 1 : scroller.scrollTop >= range - 1;
        btn.disabled = atEnd;
      });
    }

    /* rAF-coalesced: scroll fires far more often than the layout needs to be
       written, and doing this synchronously on every event is how a smooth
       gallery starts to feel heavy. */
    let queued = false;
    function onScroll() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        render();
      });
    }

    scroller.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);

    steps.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const dir = parseInt(btn.getAttribute('data-gallery-step'), 10);
        scroller.scrollBy({ top: dir * slideHeight(), behavior: 'smooth' });
      });
    });

    /* Drag and click-to-jump on the track. Pointer events rather than mouse so
       a trackpad, a pen and a touch device all land in the same path. */
    function scrollToPointer(clientY) {
      const rect = track.getBoundingClientRect();
      const thumbH = thumb.getBoundingClientRect().height;
      const usable = rect.height - thumbH;
      if (usable <= 0) return;
      let pos = clientY - rect.top - thumbH / 2;
      pos = Math.max(0, Math.min(usable, pos));
      scroller.scrollTop = (pos / usable) * (scroller.scrollHeight - scroller.clientHeight);
    }

    track.addEventListener('pointerdown', function (e) {
      dragging = true;
      track.setPointerCapture(e.pointerId);
      scrollToPointer(e.clientY);
      e.preventDefault();
    });
    track.addEventListener('pointermove', function (e) {
      if (dragging) scrollToPointer(e.clientY);
    });
    function endDrag(e) {
      if (!dragging) return;
      dragging = false;
      if (track.hasPointerCapture && track.hasPointerCapture(e.pointerId)) {
        track.releasePointerCapture(e.pointerId);
      }
    }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    /* Images arriving late change scrollHeight, which changes the thumb. */
    scroller.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', onScroll, { once: true });
    });

    render();
  })();

  let drawerOpener = null;

  /* PDP disclosure drawers — Description / Fabric Care / Size Chart
     Generic: a trigger names its dialog with aria-controls, so a fourth drawer
     needs no JS. The size chart used to have its own near-identical open /
     close / click-outside block here; it is now just another .pdp-drawer, and
     the duplicate controller was removed rather than left to drift.

     showModal() brings the focus trap, Escape and background inertness.

     Note the split: per-TRIGGER listeners open and record who opened, but the
     close/backdrop/cleanup listeners bind once per DIALOG. The size chart has
     two triggers — the buy-panel row and the sticky bar's button — and binding
     cleanup per trigger would give that dialog two close handlers racing to
     hand focus back to whichever element registered last, rather than to the
     one the shopper actually pressed. */
  const drawersBound = [];
  document.querySelectorAll('[data-drawer-trigger]').forEach(function (trigger) {
    const drawer = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!drawer) return;

    trigger.addEventListener('click', function () {
      drawerOpener = trigger;
      if (typeof drawer.showModal === 'function') drawer.showModal();
      else drawer.setAttribute('open', '');
      /* showModal() stops the page scrolling in most browsers but not all, and
         a drawer that lets the page slide behind it reads as broken. */
      document.body.style.overflow = 'hidden';
    });

    if (drawersBound.indexOf(drawer) !== -1) return;
    drawersBound.push(drawer);

    function closeDrawer() {
      if (typeof drawer.close === 'function') drawer.close();
      else drawer.removeAttribute('open');
    }

    drawer.addEventListener('close', function () {
      document.body.style.overflow = '';
      /* Native <dialog> restores focus to the opener on its own in current
         browsers; do it explicitly so the older `open` attribute fallback above
         does not strand focus on a hidden element — and so a two-trigger drawer
         returns focus to the control that was actually used. */
      if (drawerOpener) drawerOpener.focus();
    });

    drawer.querySelectorAll('[data-drawer-close]').forEach(function (btn) {
      btn.addEventListener('click', closeDrawer);
    });

    /* Click outside the panel. The dialog element IS the panel here — it is
       pinned to the right edge — so anything outside its box is backdrop. */
    drawer.addEventListener('click', function (e) {
      const rect = drawer.getBoundingClientRect();
      const inside =
        e.clientX >= rect.left &&
        e.clientX <= rect.right &&
        e.clientY >= rect.top &&
        e.clientY <= rect.bottom;
      if (!inside) closeDrawer();
    });
  });

  /* Capture-phase guard — no click on a sold-out option can ever propagate */
  document.addEventListener('click', function (e) {
    const target = e.target.closest('.size-btn.is-sold-out, .color-swatch.is-sold-out');
    if (target) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);

  /* PDP Hero — click-to-zoom lightbox */
  const heroLightbox = document.getElementById('hero-lightbox');
  const heroImgsForZoom = document.querySelectorAll('.pdp-hero__img');
  if (heroLightbox && heroImgsForZoom.length > 0) {
    const lightboxImg = heroLightbox.querySelector('.hero-lightbox__img');
    const lightboxCounter = heroLightbox.querySelector('.hero-lightbox__counter');
    const lightboxPrev = heroLightbox.querySelector('[data-lightbox-prev]');
    const lightboxNext = heroLightbox.querySelector('[data-lightbox-next]');
    const lightboxClose = heroLightbox.querySelector('[data-lightbox-close]');
    const lightboxStage = heroLightbox.querySelector('.hero-lightbox__stage');

    const heroImgsArr = Array.from(heroImgsForZoom);
    const total = heroImgsArr.length;
    let currentZoomIndex = 0;

    function getHighResSrc(img) {
      const baseSrc = img.currentSrc || img.src;
      // Bump Shopify CDN width to 2400 for a sharper zoom
      return baseSrc.replace(/([?&])width=\d+/, '$1width=2400');
    }

    function showZoom(idx) {
      currentZoomIndex = ((idx % total) + total) % total;
      const sourceImg = heroImgsArr[currentZoomIndex];
      lightboxImg.src = getHighResSrc(sourceImg);
      lightboxImg.alt = sourceImg.alt || '';
      if (lightboxCounter) {
        lightboxCounter.textContent = (currentZoomIndex + 1) + ' / ' + total;
      }
      const onlyOne = total <= 1;
      if (lightboxPrev) lightboxPrev.style.display = onlyOne ? 'none' : '';
      if (lightboxNext) lightboxNext.style.display = onlyOne ? 'none' : '';
      if (lightboxCounter) lightboxCounter.style.display = onlyOne ? 'none' : '';
    }

    function openZoom(idx) {
      showZoom(idx);
      if (typeof heroLightbox.showModal === 'function') {
        heroLightbox.showModal();
      } else {
        heroLightbox.setAttribute('open', '');
      }
    }

    function closeZoom() {
      if (typeof heroLightbox.close === 'function') {
        heroLightbox.close();
      } else {
        heroLightbox.removeAttribute('open');
      }
    }

    // Bind click on each hero image — distinguish from drag
    heroImgsArr.forEach(function (img, idx) {
      let downX = 0;
      let downY = 0;
      img.addEventListener('mousedown', function (e) {
        downX = e.clientX;
        downY = e.clientY;
      });
      img.addEventListener('click', function (e) {
        const dx = Math.abs(e.clientX - downX);
        const dy = Math.abs(e.clientY - downY);
        if (dx > 6 || dy > 6) return;  // it was a drag, not a click
        e.preventDefault();
        openZoom(idx);
      });
    });

    if (lightboxPrev) lightboxPrev.addEventListener('click', function () { showZoom(currentZoomIndex - 1); });
    if (lightboxNext) lightboxNext.addEventListener('click', function () { showZoom(currentZoomIndex + 1); });
    if (lightboxClose) lightboxClose.addEventListener('click', closeZoom);
    if (lightboxStage) lightboxStage.addEventListener('click', function (e) {
      // Close when clicking the stage backdrop, but not the image itself
      if (e.target === lightboxStage) closeZoom();
    });

    // Keyboard arrow navigation while open
    heroLightbox.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') showZoom(currentZoomIndex - 1);
      if (e.key === 'ArrowRight') showZoom(currentZoomIndex + 1);
    });

    // Touch swipe navigation (mobile)
    if (lightboxStage) {
      let touchStartX = 0;
      let touchStartY = 0;
      let touchEndX = 0;
      let touchEndY = 0;
      const SWIPE_THRESHOLD = 50;     // horizontal pixels required to register as swipe
      const VERTICAL_LIMIT = 80;       // if vertical motion exceeds this, treat as scroll/dismiss, not swipe

      lightboxStage.addEventListener('touchstart', function (e) {
        const t = e.changedTouches[0];
        touchStartX = t.screenX;
        touchStartY = t.screenY;
      }, { passive: true });

      lightboxStage.addEventListener('touchend', function (e) {
        const t = e.changedTouches[0];
        touchEndX = t.screenX;
        touchEndY = t.screenY;
        const dx = touchEndX - touchStartX;
        const dy = touchEndY - touchStartY;
        if (Math.abs(dy) > VERTICAL_LIMIT) return;
        if (Math.abs(dx) < SWIPE_THRESHOLD) return;
        if (dx < 0) {
          showZoom(currentZoomIndex + 1); // swipe left → next
        } else {
          showZoom(currentZoomIndex - 1); // swipe right → prev
        }
      }, { passive: true });
    }
  }

  /* Featured kits (slim) — drag-to-scroll on desktop */
  const slimTrack = document.querySelector('.featured-kits-slim__grid');
  if (slimTrack) {
    let slimDragging = false;
    let slimStartX = 0;
    let slimScrollLeft = 0;
    slimTrack.addEventListener('mousedown', function (e) {
      slimDragging = true;
      slimStartX = e.pageX - slimTrack.offsetLeft;
      slimScrollLeft = slimTrack.scrollLeft;
      slimTrack.style.cursor = 'grabbing';
      slimTrack.style.userSelect = 'none';
    });
    slimTrack.addEventListener('mouseleave', function () {
      slimDragging = false;
      slimTrack.style.cursor = '';
      slimTrack.style.userSelect = '';
    });
    slimTrack.addEventListener('mouseup', function () {
      slimDragging = false;
      slimTrack.style.cursor = '';
      slimTrack.style.userSelect = '';
    });
    slimTrack.addEventListener('mousemove', function (e) {
      if (!slimDragging) return;
      e.preventDefault();
      slimTrack.scrollLeft = slimScrollLeft - ((e.pageX - slimTrack.offsetLeft) - slimStartX) * 1.5;
    });
  }

  /* PDP Hero gallery — horizontal scroll-snap with arrows, dots, drag */
  const heroTrack = document.querySelector('.pdp-hero__track');
  if (heroTrack) {
    const heroPrev = document.querySelector('.pdp-hero__arrow--prev');
    const heroNext = document.querySelector('.pdp-hero__arrow--next');
    const heroDots = document.querySelectorAll('.pdp-hero__dot');
    const heroSlides = heroTrack.querySelectorAll('.pdp-hero__slide');

    function heroSlideWidth() {
      const first = heroTrack.querySelector('.pdp-hero__slide');
      return first ? first.offsetWidth : heroTrack.offsetWidth;
    }

    if (heroPrev) {
      heroPrev.addEventListener('click', function () {
        heroTrack.scrollBy({ left: -heroSlideWidth(), behavior: 'smooth' });
      });
    }
    if (heroNext) {
      heroNext.addEventListener('click', function () {
        heroTrack.scrollBy({ left: heroSlideWidth(), behavior: 'smooth' });
      });
    }

    heroDots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        const idx = parseInt(dot.getAttribute('data-index'), 10);
        const target = heroSlides[idx];
        if (target) target.scrollIntoView({ inline: 'start', block: 'nearest', behavior: 'smooth' });
      });
    });

    if ('IntersectionObserver' in window && heroDots.length > 0) {
      const heroObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            const idx = Array.from(heroSlides).indexOf(entry.target);
            if (idx >= 0) {
              heroDots.forEach(function (d, i) {
                const active = i === idx;
                d.classList.toggle('is-active', active);
                d.setAttribute('aria-selected', String(active));
              });
            }
          }
        });
      }, { root: heroTrack, threshold: 0.6 });
      heroSlides.forEach(function (s) { heroObs.observe(s); });
    }

    let heroDragging = false;
    let heroStartX = 0;
    let heroScrollLeft = 0;

    heroTrack.addEventListener('mousedown', function (e) {
      heroDragging = true;
      heroStartX = e.pageX - heroTrack.offsetLeft;
      heroScrollLeft = heroTrack.scrollLeft;
      heroTrack.style.cursor = 'grabbing';
      heroTrack.style.userSelect = 'none';
    });
    heroTrack.addEventListener('mouseleave', function () {
      heroDragging = false;
      heroTrack.style.cursor = '';
      heroTrack.style.userSelect = '';
    });
    heroTrack.addEventListener('mouseup', function () {
      heroDragging = false;
      heroTrack.style.cursor = '';
      heroTrack.style.userSelect = '';
    });
    heroTrack.addEventListener('mousemove', function (e) {
      if (!heroDragging) return;
      e.preventDefault();
      const x = e.pageX - heroTrack.offsetLeft;
      heroTrack.scrollLeft = heroScrollLeft - (x - heroStartX) * 1.5;
    });
  }

  /* Contact hero — topographic backdrop generator */
  const topoHost = document.querySelector('.contact-hero__topo');
  if (topoHost && topoHost.children.length === 0) {
    const W = 1600;
    const H = 600;
    const lineCount = 38;
    const samples = 96;
    const NS = 'http://www.w3.org/2000/svg';

    const svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
    svg.setAttribute('preserveAspectRatio', 'xMidYMax slice');

    function rand(min, max) { return min + Math.random() * (max - min); }

    for (let i = 0; i < lineCount; i++) {
      const t = i / (lineCount - 1);
      const baseY = 70 + t * (H - 100);
      const amp1 = rand(18, 55) * (0.4 + 0.6 * t);
      const amp2 = rand(8, 26) * (0.3 + 0.7 * t);
      const freq1 = rand(1.4, 2.6);
      const freq2 = rand(3.0, 5.5);
      const phase1 = rand(0, Math.PI * 2);
      const phase2 = rand(0, Math.PI * 2);

      let d = '';
      for (let s = 0; s <= samples; s++) {
        const x = (s / samples) * W;
        const u = s / samples;
        const y = baseY
          - Math.sin(u * Math.PI * freq1 + phase1) * amp1
          - Math.sin(u * Math.PI * freq2 + phase2) * amp2;
        d += (s === 0 ? 'M' : 'L') + x.toFixed(1) + ' ' + y.toFixed(1) + ' ';
      }

      const path = document.createElementNS(NS, 'path');
      path.setAttribute('d', d);
      path.setAttribute('fill', 'none');
      path.setAttribute('stroke', 'rgba(255,255,255,0.55)');
      path.setAttribute('stroke-width', (0.5 + t * 0.4).toFixed(2));
      path.setAttribute('stroke-linecap', 'round');
      svg.appendChild(path);
    }

    topoHost.appendChild(svg);
  }

  /* PDP image gallery dots (mobile sync) */
  const galleryTrack = document.querySelector('.pdp__gallery-track');
  const galleryDots  = document.querySelectorAll('.gallery-dot');

  if (galleryTrack && galleryDots.length > 0) {
    const galleryImages = galleryTrack.querySelectorAll('.pdp__gallery-image');

    const dotObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            const index = Array.from(galleryImages).indexOf(entry.target);
            galleryDots.forEach(function (d, i) {
              d.classList.toggle('is-active', i === index);
              d.setAttribute('aria-selected', String(i === index));
            });
          }
        });
      },
      { root: galleryTrack, threshold: 0.5 }
    );

    galleryImages.forEach(function (img) { dotObserver.observe(img); });

    galleryDots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        const target = galleryImages[i];
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      });
    });
  }

  /* Nano carousel — horizontal scroller with drag, arrows, progress, edge fades */
  document.querySelectorAll('[data-nano-carousel]').forEach(function (wrapper) {
    const track = wrapper.querySelector('[data-nano-track]');
    const prevBtn = wrapper.querySelector('[data-nano-prev]');
    const nextBtn = wrapper.querySelector('[data-nano-next]');
    const progressBar = wrapper.querySelector('[data-nano-progress]');
    if (!track) return;

    function slideStep() {
      // .nano-carousel__slide for product carousels, [data-carousel-slide] for
      // other tracks reusing this controller (e.g. featured kits)
      const slide = track.querySelector('.nano-carousel__slide, [data-carousel-slide]');
      if (!slide) return track.clientWidth * 0.8;
      const gap = parseFloat(getComputedStyle(track).gap) || 20;
      return slide.getBoundingClientRect().width + gap;
    }

    function updateState() {
      const max = track.scrollWidth - track.clientWidth;
      const x = track.scrollLeft;
      const tolerance = 2;
      const atStart = x <= tolerance;
      const atEnd = x >= max - tolerance;
      const hasOverflow = max > tolerance;

      wrapper.classList.toggle('has-overflow-start', hasOverflow && !atStart);
      wrapper.classList.toggle('has-overflow-end', hasOverflow && !atEnd);

      if (prevBtn) prevBtn.disabled = !hasOverflow || atStart;
      if (nextBtn) nextBtn.disabled = !hasOverflow || atEnd;

      if (progressBar) {
        if (!hasOverflow) {
          progressBar.style.width = '100%';
          progressBar.style.transform = 'translateX(0)';
        } else {
          // Bar represents visible viewport relative to total scrollable content
          const visibleRatio = track.clientWidth / track.scrollWidth;
          const progress = max > 0 ? x / max : 0;
          progressBar.style.width = (visibleRatio * 100) + '%';
          progressBar.style.transform = 'translateX(' + (progress * (100 / visibleRatio - 100)) + '%)';
        }
      }
    }

    function scrollByStep(direction) {
      const step = slideStep();
      track.scrollBy({ left: step * direction, behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByStep(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByStep(1); });

    // Throttled scroll listener via rAF
    let scrollTicking = false;
    track.addEventListener('scroll', function () {
      if (scrollTicking) return;
      scrollTicking = true;
      requestAnimationFrame(function () {
        updateState();
        scrollTicking = false;
      });
    }, { passive: true });

    // Keyboard navigation when track is focused
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); scrollByStep(1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); scrollByStep(-1); }
      else if (e.key === 'Home') { e.preventDefault(); track.scrollTo({ left: 0, behavior: 'smooth' }); }
      else if (e.key === 'End') { e.preventDefault(); track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' }); }
    });

    // Mouse drag-to-scroll (desktop)
    let isDown = false;
    let startX = 0;
    let startScrollLeft = 0;
    let didDrag = false;
    const DRAG_THRESHOLD = 5; // pixels before we treat as drag (suppress clicks)

    track.addEventListener('mousedown', function (e) {
      // Only left mouse button, and not on form controls
      if (e.button !== 0) return;
      isDown = true;
      didDrag = false;
      startX = e.pageX;
      startScrollLeft = track.scrollLeft;
    });

    track.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      const dx = e.pageX - startX;
      if (!didDrag && Math.abs(dx) > DRAG_THRESHOLD) {
        didDrag = true;
        track.classList.add('is-dragging');
      }
      if (didDrag) {
        e.preventDefault();
        track.scrollLeft = startScrollLeft - dx;
      }
    });

    function endDrag() {
      if (!isDown) return;
      isDown = false;
      if (didDrag) {
        // Re-enable snap; snap to nearest slide
        track.classList.remove('is-dragging');
        const step = slideStep();
        const target = Math.round(track.scrollLeft / step) * step;
        track.scrollTo({ left: target, behavior: 'smooth' });
      }
    }

    track.addEventListener('mouseup', endDrag);
    track.addEventListener('mouseleave', endDrag);

    // Suppress click on cards when we just finished a drag
    track.addEventListener('click', function (e) {
      if (didDrag) {
        e.preventDefault();
        e.stopPropagation();
        didDrag = false;
      }
    }, true);

    // Recompute on resize and after images load
    let resizeTicking = false;
    window.addEventListener('resize', function () {
      if (resizeTicking) return;
      resizeTicking = true;
      requestAnimationFrame(function () {
        updateState();
        resizeTicking = false;
      });
    });

    track.querySelectorAll('img').forEach(function (img) {
      if (img.complete) return;
      img.addEventListener('load', updateState, { once: true });
    });

    updateState();
  });

  /* Hero statement — drifts down at a fraction of the scroll rate (Hopaal-style).
     Transform goes on the blending text spans themselves: transforming the
     container would isolate the stacking context and kill mix-blend-mode. */
  const heroStatement = document.querySelector('[data-hero-statement]');
  const heroSection = document.querySelector('.hero--statement');

  // Load-in sequence: statement lines mask-rise + hero image settles from zoom.
  // The class flips CSS transitions; drift writing is gated until the entrance finishes
  // so the inline transform doesn't stomp the CSS entrance transform.
  let heroDriftReady = false;
  if (heroSection) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      heroSection.classList.add('hero--loaded');
      heroSection.classList.add('hero--drift-ready');
      heroDriftReady = true;
    } else {
      setTimeout(function () { heroSection.classList.add('hero--loaded'); }, 100);
      setTimeout(function () {
        heroDriftReady = true;
        // Releases the entrance mask (overflow) + transition so drift is unclipped
        heroSection.classList.add('hero--drift-ready');
      }, 1500);
    }
  } else {
    heroDriftReady = true;
  }

  if (heroStatement && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const heroStFactor = parseFloat(heroStatement.getAttribute('data-parallax')) || 0;
    const heroStTexts = heroStatement.querySelectorAll('[data-hero-statement-text]');
    // Smoothed drift (Lenis-style lerp): scroll only sets a target; a rAF loop
    // eases the text toward it. Wheel scrolling is stepped, so writing the
    // position straight from the scroll event looks jittery — the easing
    // absorbs the steps and adds the floaty trail the reference has.
    let heroStTarget = 0;
    let heroStCurrent = 0;
    let heroStRaf = null;
    // Mobile: shorter viewport + flicky touch scrolling makes the same drift
    // factor feel rushed — scale it down
    const driftMobileMq = window.matchMedia('(max-width: 767px)');

    function heroStTick() {
      heroStCurrent += (heroStTarget - heroStCurrent) * (driftMobileMq.matches ? 0.045 : 0.06);
      if (Math.abs(heroStTarget - heroStCurrent) < 0.05) {
        heroStCurrent = heroStTarget;
        heroStRaf = null;
      } else {
        heroStRaf = requestAnimationFrame(heroStTick);
      }
      const ty = heroStCurrent.toFixed(2);
      heroStTexts.forEach(function (el) {
        el.style.transform = 'translate3d(0,' + ty + 'px,0)';
      });
    }

    function heroStOnScroll() {
      if (!heroDriftReady) return;
      // Past 1.5 viewport heights the hero is long gone — clamp instead of
      // freezing so the easing can still settle cleanly
      const limit = (window.innerHeight || 800) * 1.5;
      const f = heroStFactor * (driftMobileMq.matches ? 0.4 : 1);
      heroStTarget = Math.min(window.scrollY || 0, limit) * f;
      if (heroStRaf === null) heroStRaf = requestAnimationFrame(heroStTick);
    }

    if (heroStFactor > 0 && heroStTexts.length > 0) {
      window.addEventListener('scroll', heroStOnScroll, { passive: true });
      // Sync once the entrance gate opens (covers scrolling during the load-in)
      setTimeout(heroStOnScroll, 1550);
    }
  }

  /* Footer uncover — fixed footer behind the page; body reserves scroll runway */
  const uncoverFooter = document.querySelector('.site-footer');
  const pageMain = document.querySelector('main.page-content');
  if (uncoverFooter && pageMain && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.body.classList.add('has-footer-uncover');
    let footerMeasureTick = false;

    function measureFooter() {
      const h = uncoverFooter.offsetHeight;
      document.body.style.marginBottom = h + 'px';
      footerMeasureTick = false;
    }

    measureFooter();
    // Re-measure after fonts/images settle, and on resize
    setTimeout(measureFooter, 800);
    window.addEventListener('load', measureFooter);
    window.addEventListener('resize', function () {
      if (footerMeasureTick) return;
      footerMeasureTick = true;
      requestAnimationFrame(measureFooter);
    });
  }

  /* Category tile parallax — JS drives --par; hover zoom stays in CSS via --tile-zoom */
  const parallaxTiles = document.querySelectorAll('[data-parallax-bg]');
  if (parallaxTiles.length > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    let tileTicking = false;

    function updateTileParallax() {
      const vh = window.innerHeight || 1;
      parallaxTiles.forEach(function (tile) {
        const rect = tile.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > vh) return;
        const centerOffset = (rect.top + rect.height / 2) - vh / 2; // px from viewport center
        const par = Math.max(-rect.height * 0.08, Math.min(rect.height * 0.08, centerOffset * -0.06));
        const bg = tile.querySelector('.category-tile__bg');
        if (bg) bg.style.setProperty('--par', par.toFixed(1) + 'px');
      });
      tileTicking = false;
    }

    window.addEventListener('scroll', function () {
      if (tileTicking) return;
      tileTicking = true;
      requestAnimationFrame(updateTileParallax);
    }, { passive: true });
    updateTileParallax();
  }

  /* Blend statement — Hopaal hero behavior: text sits centered while the
     section is in view; once the section starts scrolling out past the top,
     the lines lag hard behind the scroll (near-pinned in the viewport), so
     they ride down the full length of the image and finally slide out
     through the section's bottom edge (overflow:hidden does the clipping).
     Transform goes on the spans; transforming a wrapper would kill
     mix-blend-mode. */
  const blendStatements = document.querySelectorAll('[data-blend-statement]');
  if (blendStatements.length > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    // Same smoothed-lerp approach as the hero statement (see above)
    const blendItems = [];
    blendStatements.forEach(function (sec) {
      blendItems.push({
        sec: sec,
        lines: sec.querySelectorAll('[data-blend-line]'),
        factor: parseFloat(sec.getAttribute('data-parallax')) || 0,
        current: 0,
        target: 0
      });
    });
    let blendRaf = null;
    // Same mobile drift scaling as the hero statement
    const blendMobileMq = window.matchMedia('(max-width: 767px)');

    function blendTick() {
      let active = false;
      blendItems.forEach(function (it) {
        const delta = it.target - it.current;
        if (Math.abs(delta) < 0.05) {
          it.current = it.target;
        } else {
          it.current += delta * (blendMobileMq.matches ? 0.045 : 0.06);
          active = true;
        }
        const ty = it.current.toFixed(2);
        it.lines.forEach(function (line) {
          line.style.transform = 'translate3d(0,' + ty + 'px,0)';
        });
      });
      blendRaf = active ? requestAnimationFrame(blendTick) : null;
    }

    function blendOnScroll() {
      const vh = window.innerHeight || 1;
      blendItems.forEach(function (it) {
        const rect = it.sec.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > vh) return; // off-screen: keep last target
        it.target = Math.max(0, -rect.top) * it.factor * (blendMobileMq.matches ? 0.4 : 1);
      });
      if (blendRaf === null) blendRaf = requestAnimationFrame(blendTick);
    }

    window.addEventListener('scroll', blendOnScroll, { passive: true });
    blendOnScroll();
  }

  /* Nano carousel — tab switcher */
  document.querySelectorAll('.nano-carousel').forEach(function (section) {
    const tabs = section.querySelectorAll('[data-tab-index]');
    const panels = section.querySelectorAll('[data-tab-panel-index]');
    const viewAllLink = section.querySelector('[data-nano-view-all]');
    if (tabs.length === 0) return;

    const viewAllOverride = viewAllLink && viewAllLink.getAttribute('data-view-all-override') === 'true';

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        const idx = tab.getAttribute('data-tab-index');

        tabs.forEach(function (t) {
          const isActive = t === tab;
          t.classList.toggle('is-active', isActive);
          t.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach(function (p) {
          const isActive = p.getAttribute('data-tab-panel-index') === idx;
          p.classList.toggle('is-active', isActive);
          if (isActive) {
            // Re-measure the newly-visible carousel — measurements were 0 while display:none
            const track = p.querySelector('[data-nano-track]');
            if (track) {
              track.scrollLeft = 0;
              track.dispatchEvent(new Event('scroll'));
            }
          }
        });

        if (viewAllLink && !viewAllOverride) {
          const url = tab.getAttribute('data-view-all-url');
          if (url) viewAllLink.setAttribute('href', url);
        }
      });
    });
  });

  /* Product card — quick add to cart */
  function refreshHeaderCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        document.querySelectorAll('.header__cart-count').forEach(function (el) {
          el.textContent = 'P (' + cart.item_count + ')';
        });
        document.querySelectorAll('.header__icon-link[aria-label^="Cart"]').forEach(function (el) {
          el.setAttribute('aria-label', 'Cart — ' + cart.item_count + ' items');
        });
      })
      .catch(function () {});
  }

  /* ============================================================
     Cart drawer — AJAX slide-out with free-shipping progress
     ============================================================ */
  const cartDrawer = document.getElementById('unvxt-cart-drawer');

  function escapeCartHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Discount names attached to a line. The property is
     line_level_discount_allocations — /cart.js does NOT expose an item-level
     `discount_allocations`, which is the name the Storefront/AJAX docs lead you
     to and which silently yields an empty list. Each entry carries a
     discount_application.title. */
  function cartLineDiscounts(item) {
    const allocs = (item.line_level_discount_allocations || item.discount_allocations || []).filter(function (a) {
      return a && a.amount > 0;
    });
    if (!allocs.length) return '';
    return '<ul class="unvxt-cart__item-discounts">' + allocs.map(function (a) {
      const title = (a.discount_application && a.discount_application.title) || 'Discount';
      return '<li>' + escapeCartHtml(title) + '</li>';
    }).join('') + '</ul>';
  }

  /* The ship promise travels as a line item property set by the buy panel, so
     /cart.js hands it back on `properties` with no extra request. Reading the
     property rather than re-deriving from the product is what keeps the drawer,
     the checkout and the order confirmation saying the same thing. */
  function cartLineShips(item) {
    var props = item.properties || {};
    var ships = props.Ships || props.ships;
    if (!ships) return '';
    return '<p class="unvxt-cart__item-ships">' + escapeCartHtml(String(ships)) + '</p>';
  }

  function renderCartDrawer(cart) {
    if (!cartDrawer || !cart) return;
    const itemsEl = cartDrawer.querySelector('[data-unvxt-cart-items]');
    const emptyEl = cartDrawer.querySelector('[data-unvxt-cart-empty]');
    const footerEl = cartDrawer.querySelector('[data-unvxt-cart-footer]');
    const countEl = cartDrawer.querySelector('[data-unvxt-cart-count]');
    const subtotalEl = cartDrawer.querySelector('[data-unvxt-cart-subtotal]');

    if (countEl) countEl.textContent = '(' + cart.item_count + ')';
    if (subtotalEl) subtotalEl.textContent = '$' + (cart.items_subtotal_price / 100).toFixed(2);

    /* Total saved, stated once. items_subtotal_price is already net of this, so
       without the line the shopper has no confirmation the set discount landed. */
    const savedEl = cartDrawer.querySelector('[data-unvxt-cart-saved]');
    if (savedEl) {
      const saved = cart.total_discount || 0;
      savedEl.hidden = saved <= 0;
      const amtEl = savedEl.querySelector('[data-unvxt-cart-saved-amount]');
      if (amtEl) amtEl.textContent = '\u2212$' + (saved / 100).toFixed(2);
    }

    /* Order-level codes (every athlete code, GovX) come off total_price, not
       items_subtotal_price, so the subtotal above does not move when one lands.
       Name the code and show the real Total, or a bigger "You saved" sits next
       to an unchanged subtotal and reads as a pricing bug.
       The AJAX API returns these in TWO shapes depending on the endpoint:
         GET  /cart.js         flat   { title, total_allocated_amount, ... }
         POST /cart/update.js  nested { amount, discount_application: { title } }
       The drawer renders from both (opening it vs applying a code), so read
       either. Handling only the nested one left the code line blank whenever
       the drawer opened on a cart that already had a code — e.g. anyone who
       arrived through an athlete's /discount/CODE link. */
    const codeLinesEl = cartDrawer.querySelector('[data-unvxt-cart-codelines]');
    const cartLevel = (cart.cart_level_discount_applications || []).map(function (a) {
      const app = (a && a.discount_application) || a || {};
      return {
        title: app.title || 'Discount',
        amount: a && a.amount != null ? a.amount : app.total_allocated_amount
      };
    }).filter(function (a) {
      return a.amount > 0;
    });
    if (codeLinesEl) {
      codeLinesEl.innerHTML = cartLevel.map(function (a) {
        return '<div class="unvxt-cart__codeline"><span>' + escapeCartHtml(a.title) + '</span>' +
          '<span>−$' + (a.amount / 100).toFixed(2) + '</span></div>';
      }).join('');
      codeLinesEl.hidden = cartLevel.length === 0;
    }
    const totalEl = cartDrawer.querySelector('[data-unvxt-cart-total]');
    if (totalEl) {
      totalEl.hidden = cart.total_price === cart.items_subtotal_price;
      const totalAmtEl = totalEl.querySelector('[data-unvxt-cart-total-amount]');
      if (totalAmtEl) totalAmtEl.textContent = '$' + (cart.total_price / 100).toFixed(2);
    }

    cartDrawer.querySelectorAll('[data-cart-code]').forEach(function (root) {
      syncCartCode(root, cart);
    });

    const isEmpty = cart.item_count === 0;
    if (emptyEl) emptyEl.hidden = !isEmpty;
    if (footerEl) footerEl.hidden = isEmpty;
    if (itemsEl) itemsEl.style.display = isEmpty ? 'none' : '';

    // Free-shipping progress
    const shipbar = cartDrawer.querySelector('[data-unvxt-cart-shipbar]');
    if (shipbar) {
      const threshold = parseInt(cartDrawer.getAttribute('data-fs-threshold'), 10) || 13000;
      const textEl = shipbar.querySelector('[data-unvxt-cart-shipbar-text]');
      const fillEl = shipbar.querySelector('[data-unvxt-cart-shipbar-fill]');
      /* Measured AFTER every discount, codes included. Whether Free Ship 130
         checks its $130 before or after discounts is unresolved (CLAUDE.md), so
         use the figure that can only under-promise. items_subtotal_price would
         ignore an order code and could tell someone they unlocked free shipping
         that checkout then charges for. */
      const subtotal = cart.total_price;
      const pct = Math.min(100, (subtotal / threshold) * 100);
      if (fillEl) fillEl.style.width = pct + '%';
      if (textEl) {
        if (subtotal >= threshold) {
          shipbar.classList.add('is-unlocked');
          textEl.innerHTML = '&#10003; Free shipping unlocked';
        } else {
          shipbar.classList.remove('is-unlocked');
          const away = ((threshold - subtotal) / 100).toFixed(2);
          textEl.innerHTML = "You're <strong>$" + away + '</strong> away from free shipping';
        }
      }
    }

    if (!itemsEl) return;
    if (isEmpty) { itemsEl.innerHTML = ''; return; }

    let html = '';
    cart.items.forEach(function (item) {
      let img = item.image || '';
      if (img.indexOf('//') === 0) img = 'https:' + img;
      if (img) {
        const sep = img.indexOf('?') > -1 ? '&' : '?';
        img = img + sep + 'width=160';
      }
      const variantLabel = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
      html +=
        '<div class="unvxt-cart__item" data-line-key="' + escapeCartHtml(item.key) + '">' +
          (img ? '<img class="unvxt-cart__item-img" src="' + img + '" alt="" loading="lazy" decoding="async">' : '<span class="unvxt-cart__item-img"></span>') +
          '<div class="unvxt-cart__item-info">' +
            '<a class="unvxt-cart__item-title" href="' + escapeCartHtml(item.url) + '">' + escapeCartHtml(item.product_title) + '</a>' +
            (variantLabel ? '<p class="unvxt-cart__item-variant">' + escapeCartHtml(variantLabel) + '</p>' : '') +
            /* A pre-order line is charged today and ships later. Without this the
               drawer shows it as an ordinary line and the customer has no way to
               tell which half of a mixed cart is the one they are waiting for. */
            cartLineShips(item) +
            '<div class="unvxt-cart__qty">' +
              '<button type="button" class="unvxt-cart__qty-btn" data-cart-qty-down aria-label="Decrease quantity">&minus;</button>' +
              '<span class="unvxt-cart__qty-num">' + item.quantity + '</span>' +
              '<button type="button" class="unvxt-cart__qty-btn" data-cart-qty-up aria-label="Increase quantity">+</button>' +
            '</div>' +
          '</div>' +
          '<div class="unvxt-cart__item-side">' +
            /* A discounted line came back from /cart.js already reduced, so
               without this the drawer just showed a number quietly lower than
               the PDP with nothing to explain it — which reads as a pricing bug
               rather than a reward. Strike the original and name the discount. */
            (item.original_line_price !== item.final_line_price
              ? '<p class="unvxt-cart__item-price">' +
                  '<s class="unvxt-cart__item-was">$' + (item.original_line_price / 100).toFixed(2) + '</s> ' +
                  '<span class="unvxt-cart__item-now">$' + (item.final_line_price / 100).toFixed(2) + '</span>' +
                '</p>'
              : '<p class="unvxt-cart__item-price">$' + (item.final_line_price / 100).toFixed(2) + '</p>') +
            cartLineDiscounts(item) +
            '<button type="button" class="unvxt-cart__item-remove" data-cart-remove>Remove</button>' +
          '</div>' +
        '</div>';
    });
    itemsEl.innerHTML = html;
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; });
  }

  function openCartDrawer() {
    if (!cartDrawer) return;
    fetchCart().then(function (cart) {
      renderCartDrawer(cart);
      cartDrawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    });
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function changeCartLine(lineKey, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (cart) {
          renderCartDrawer(cart);
          refreshHeaderCartCount();
        }
      });
  }

  if (cartDrawer) {
    cartDrawer.querySelectorAll('[data-unvxt-cart-close]').forEach(function (el) {
      el.addEventListener('click', closeCartDrawer);
    });

    // Qty +/− and remove (delegated)
    cartDrawer.addEventListener('click', function (e) {
      const itemEl = e.target.closest('.unvxt-cart__item');
      if (!itemEl) return;
      const key = itemEl.getAttribute('data-line-key');
      const qtyEl = itemEl.querySelector('.unvxt-cart__qty-num');
      const currentQty = qtyEl ? parseInt(qtyEl.textContent, 10) || 1 : 1;

      if (e.target.closest('[data-cart-remove]')) {
        changeCartLine(key, 0);
      } else if (e.target.closest('[data-cart-qty-up]')) {
        changeCartLine(key, currentQty + 1);
      } else if (e.target.closest('[data-cart-qty-down]')) {
        changeCartLine(key, Math.max(0, currentQty - 1));
      }
    });

    // Header cart icon opens drawer instead of navigating (href stays as no-JS fallback)
    document.querySelectorAll('.header__icon-link[aria-label^="Cart"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        openCartDrawer();
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && cartDrawer.getAttribute('aria-hidden') === 'false') closeCartDrawer();
    });

    // PDP buy form — intercept native submit, AJAX add, open drawer.
    // On any failure, fall back to native submit so checkout is never blocked.
    const pdpForm = document.getElementById('product-form');
    if (pdpForm) {
      pdpForm.addEventListener('submit', function (e) {
        e.preventDefault();
        const fd = new FormData(pdpForm);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: fd
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add_failed');
            return r.json();
          })
          .then(function () {
            refreshHeaderCartCount();
            openCartDrawer();
          })
          .catch(function () {
            pdpForm.submit();
          });
      });
    }
  }

  /* ============================================================
     Affiliate code — snippets/cart-code.liquid, drawer and /cart
     ============================================================ */

  /* /cart/update.js `discount` REPLACES the cart's whole code list rather than
     adding to it. That is the stacking rule for free — the set discount plus
     one code (CLAUDE.md, "Stacking"). An empty string clears it. */
  function setCartDiscount(code) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: code })
    }).then(function (r) {
      if (!r.ok) throw new Error('discount_update_failed');
      return r.json();
    });
  }

  function appliedCartCode(cart) {
    const codes = (cart && cart.discount_codes) || [];
    for (let i = 0; i < codes.length; i++) {
      if (codes[i] && codes[i].applicable) return codes[i].code;
    }
    return '';
  }

  /* A function declaration on purpose: renderCartDrawer calls it on every
     render, so a code that arrived through an athlete's /discount/CODE link
     already shows as applied the first time the drawer opens.
     While a code is applied the entry panel is hidden, so a shopper has to
     Remove it before typing another — which also means a typo can never wipe
     out a code that was working (update.js would replace it). */
  function syncCartCode(root, cart) {
    const code = appliedCartCode(cart);
    const toggle = root.querySelector('[data-cart-code-toggle]');
    const panel = root.querySelector('[data-cart-code-panel]');
    const applied = root.querySelector('[data-cart-code-applied]');
    const nameEl = root.querySelector('[data-cart-code-name]');
    if (applied) applied.hidden = !code;
    if (nameEl) nameEl.textContent = code ? String(code).toUpperCase() : '';
    if (toggle) toggle.hidden = !!code;
    if (panel) panel.hidden = !!code || !toggle || toggle.getAttribute('aria-expanded') !== 'true';
  }

  function cartCodeMessage(root, text) {
    const msg = root.querySelector('[data-cart-code-msg]');
    if (msg) msg.textContent = text || '';
  }

  /* The drawer re-renders from the returned cart. The cart page is
     server-rendered Liquid, so it reloads to pick up the new totals. */
  function afterCartCodeChange(root, cart) {
    if (root.closest('#unvxt-cart-drawer')) {
      renderCartDrawer(cart);
      refreshHeaderCartCount();
    } else {
      window.location.reload();
    }
  }

  function applyCartCodeFrom(root) {
    const input = root.querySelector('[data-cart-code-input]');
    const btn = root.querySelector('[data-cart-code-apply]');
    const code = input ? input.value.trim() : '';
    if (!code) {
      cartCodeMessage(root, 'Enter a code first.');
      if (input) input.focus();
      return;
    }
    if (btn) btn.disabled = true;
    cartCodeMessage(root, '');
    setCartDiscount(code)
      .then(function (cart) {
        const hit = (cart.discount_codes || []).filter(function (d) {
          return d && String(d.code).toLowerCase() === code.toLowerCase();
        })[0];
        if (hit && hit.applicable) {
          if (input) input.value = '';
          afterCartCodeChange(root, cart);
          return;
        }
        /* Unknown, expired, or not valid for this cart. Shopify keeps it on the
           cart as applicable:false, so take it back off — otherwise a dead code
           rides along to checkout — then say so. Totals didn't move, so the
           cart page needs no reload and the message stays visible. */
        return setCartDiscount('').then(function (cleared) {
          if (root.closest('#unvxt-cart-drawer')) renderCartDrawer(cleared);
          cartCodeMessage(root, "That code can't be applied to this cart.");
        });
      })
      .catch(function () {
        cartCodeMessage(root, "Couldn't apply the code. Try again.");
      })
      .then(function () {
        if (btn) btn.disabled = false;
      });
  }

  function removeCartCodeFrom(root) {
    const btn = root.querySelector('[data-cart-code-remove]');
    const toggle = root.querySelector('[data-cart-code-toggle]');
    if (btn) btn.disabled = true;
    setCartDiscount('')
      .then(function (cart) {
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
        cartCodeMessage(root, '');
        afterCartCodeChange(root, cart);
      })
      .catch(function () {
        cartCodeMessage(root, "Couldn't remove the code. Try again.");
      })
      .then(function () {
        if (btn) btn.disabled = false;
      });
  }

  // Delegated, so the drawer's instance and the cart page's both work.
  document.addEventListener('click', function (e) {
    const root = e.target.closest && e.target.closest('[data-cart-code]');
    if (!root) return;
    const toggle = e.target.closest('[data-cart-code-toggle]');
    if (toggle) {
      const panel = root.querySelector('[data-cart-code-panel]');
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (panel) panel.hidden = !open;
      if (open) {
        const input = root.querySelector('[data-cart-code-input]');
        if (input) input.focus();
      }
    } else if (e.target.closest('[data-cart-code-apply]')) {
      applyCartCodeFrom(root);
    } else if (e.target.closest('[data-cart-code-remove]')) {
      removeCartCodeFrom(root);
    }
  });

  /* Enter applies. On /cart the field sits inside the cart's own <form>, so
     without preventDefault Enter would submit that form instead. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target.matches || !e.target.matches('[data-cart-code-input]')) return;
    e.preventDefault();
    const root = e.target.closest('[data-cart-code]');
    if (root) applyCartCodeFrom(root);
  });

  /* The cart page's field has no idea which code is on the cart, so hydrate it
     once from /cart.js. The drawer's instance is synced by renderCartDrawer. */
  document.querySelectorAll('[data-cart-code]').forEach(function (root) {
    if (root.closest('#unvxt-cart-drawer')) return;
    fetchCart().then(function (cart) {
      if (cart) syncCartCode(root, cart);
    });
  });

  /* ============================================================
     Search overlay — predictive results via /search/suggest.json
     ============================================================ */
  const searchOverlay = document.getElementById('unvxt-search-overlay');
  if (searchOverlay) {
    const searchInput = searchOverlay.querySelector('[data-unvxt-search-input]');
    const resultsWrap = searchOverlay.querySelector('[data-unvxt-search-results]');
    const resultsGrid = searchOverlay.querySelector('[data-unvxt-search-grid]');
    const noneEl = searchOverlay.querySelector('[data-unvxt-search-none]');
    const allLink = searchOverlay.querySelector('[data-unvxt-search-all]');
    let searchTimer = null;
    let searchSeq = 0;

    function openSearch() {
      searchOverlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setTimeout(function () { if (searchInput) searchInput.focus(); }, 50);
    }
    function closeSearch() {
      searchOverlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    document.querySelectorAll('[data-unvxt-search-open]').forEach(function (btn) {
      btn.addEventListener('click', openSearch);
    });
    searchOverlay.querySelectorAll('[data-unvxt-search-close]').forEach(function (el) {
      el.addEventListener('click', closeSearch);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && searchOverlay.getAttribute('aria-hidden') === 'false') closeSearch();
    });

    function runSearch(query) {
      const seq = ++searchSeq;
      const url = '/search/suggest.json?q=' + encodeURIComponent(query) +
        '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (seq !== searchSeq) return; // stale response
          const products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
          if (allLink) allLink.setAttribute('href', '/search?q=' + encodeURIComponent(query));
          if (products.length === 0) {
            if (resultsWrap) resultsWrap.hidden = true;
            if (noneEl) noneEl.hidden = false;
            return;
          }
          if (noneEl) noneEl.hidden = true;
          let html = '';
          products.forEach(function (p) {
            let img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
            if (img && img.indexOf('//') === 0) img = 'https:' + img;
            if (img) {
              const sep = img.indexOf('?') > -1 ? '&' : '?';
              img = img + sep + 'width=400';
            }
            html +=
              '<a class="unvxt-search__result" href="' + escapeCartHtml(p.url) + '">' +
                (img ? '<img src="' + img + '" alt="' + escapeCartHtml(p.title) + '" loading="lazy" decoding="async">' : '') +
                '<p class="unvxt-search__result-title">' + escapeCartHtml(p.title) + '</p>' +
                '<p class="unvxt-search__result-price">$' + p.price + '</p>' +
              '</a>';
          });
          if (resultsGrid) resultsGrid.innerHTML = html;
          if (resultsWrap) resultsWrap.hidden = false;
        })
        .catch(function () {});
    }

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        const q = searchInput.value.trim();
        clearTimeout(searchTimer);
        if (q.length < 2) {
          if (resultsWrap) resultsWrap.hidden = true;
          if (noneEl) noneEl.hidden = true;
          return;
        }
        searchTimer = setTimeout(function () { runSearch(q); }, 250);
      });
    }
  }

  /* Quick-add modal */
  const quickAddModal = document.getElementById('quick-add-modal');
  const quickAddState = {
    product: null,
    selected: [],
    productCache: {},
    qty: 1,
    activeSlide: 0
  };
  const QUICK_ADD_MAX_QTY = 10;

  function quickAddOpen() {
    if (!quickAddModal) return;
    if (typeof quickAddModal.showModal === 'function') {
      quickAddModal.showModal();
    } else {
      quickAddModal.setAttribute('open', '');
    }
    quickAddModal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function quickAddClose() {
    if (!quickAddModal) return;
    if (typeof quickAddModal.close === 'function') {
      quickAddModal.close();
    } else {
      quickAddModal.removeAttribute('open');
    }
    quickAddModal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    quickAddModal.style.transform = '';
    quickAddModal.classList.remove('is-dragging');
    quickAddState.product = null;
    quickAddState.selected = [];
    quickAddState.qty = 1;
    const qtyInput = quickAddModal.querySelector('[data-qty-input]');
    if (qtyInput) qtyInput.value = '1';
  }

  function quickAddFindVariant() {
    if (!quickAddState.product) return null;
    return quickAddState.product.variants.find(function (v) {
      for (let i = 0; i < quickAddState.selected.length; i++) {
        const sel = quickAddState.selected[i];
        if (sel == null) return false;
        const optVal = v['option' + (i + 1)];
        if (String(optVal).toLowerCase().trim() !== String(sel).toLowerCase().trim()) {
          return false;
        }
      }
      return true;
    });
  }

  function quickAddVariantAvailableFor(idx, candidateValue) {
    if (!quickAddState.product) return false;
    return quickAddState.product.variants.some(function (v) {
      if (!v.available) return false;
      for (let i = 0; i < quickAddState.product.options.length; i++) {
        if (i === idx) {
          if (String(v['option' + (i + 1)]).toLowerCase().trim() !== String(candidateValue).toLowerCase().trim()) return false;
        } else if (quickAddState.selected[i] != null) {
          if (String(v['option' + (i + 1)]).toLowerCase().trim() !== String(quickAddState.selected[i]).toLowerCase().trim()) return false;
        }
      }
      return true;
    });
  }

  function quickAddUpdateUI() {
    if (!quickAddState.product) return;

    quickAddModal.querySelectorAll('.quick-add__opt-btn').forEach(function (btn) {
      const idx = parseInt(btn.getAttribute('data-option-index'), 10);
      const val = btn.getAttribute('data-option-value');
      btn.classList.toggle('is-selected', quickAddState.selected[idx] === val);
      btn.classList.toggle('is-sold-out', !quickAddVariantAvailableFor(idx, val));
    });

    quickAddModal.querySelectorAll('[data-selected-for]').forEach(function (el) {
      const idx = parseInt(el.getAttribute('data-selected-for'), 10);
      el.textContent = quickAddState.selected[idx] || '';
    });

    const variant = quickAddFindVariant();
    const priceEl = quickAddModal.querySelector('[data-quick-add-price]');
    const submitBtn = quickAddModal.querySelector('[data-quick-add-submit]');
    const submitLabel = quickAddModal.querySelector('[data-quick-add-submit-label]');

    if (variant) {
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (variant.available) {
        submitBtn.disabled = false;
        /* Set here, not at render time: this runs on every selection change and
           would otherwise overwrite it back to "Add to Cart" the moment someone
           picks a size. */
        submitLabel.textContent = quickAddState.ships ? 'Pre-Order' : 'Add to Cart';
      } else {
        submitBtn.disabled = true;
        submitLabel.textContent = 'Sold Out';
      }
    } else {
      /* Nothing chosen yet: show the product's own price rather than leaving
         whatever the last-opened product left behind. Say "From" when the runs
         differ — the adult/youth pre-orders are $69.99 and $49.99, and a bare
         $49.99 above an adult size row reads as the price of that size. */
      if (priceEl && quickAddState.product) {
        const p = quickAddState.product;
        priceEl.textContent = p.price_varies
          ? 'From ' + formatMoney(p.price_min)
          : formatMoney(p.price);
      }
      submitBtn.disabled = true;
      submitLabel.textContent = 'Select options';
    }
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function isColorOption(name) {
    const n = String(name || '').toLowerCase();
    return n === 'color' || n === 'colour';
  }

  function colorToSwatch(value) {
    const v = String(value || '').toLowerCase().trim();
    const map = {
      black: '#000000', white: '#ffffff', grey: '#808080', gray: '#808080',
      red: '#C0392B', blue: '#1F3A93', navy: '#1a2540', green: '#2E7D32',
      olive: '#556b2f', tan: '#D2B48C', brown: '#5C4033', beige: '#dcc9a3',
      cream: '#f5f0e1', charcoal: '#36454F', sand: '#c2b280'
    };
    return map[v] || v;
  }

  function findVariantImage(product, optionIdx, value) {
    const target = String(value).toLowerCase().trim();
    const variant = product.variants.find(function (v) {
      return v.featured_image && v.featured_image.src &&
        String(v['option' + (optionIdx + 1)]).toLowerCase().trim() === target;
    });
    if (!variant) return null;
    let src = variant.featured_image.src;
    if (src.indexOf('//') === 0) src = 'https:' + src;
    const sep = src.indexOf('?') > -1 ? '&' : '?';
    return src + sep + 'width=80&height=80&crop=center';
  }

  function quickAddRender(product) {
    quickAddState.product = product;
    quickAddState.selected = (product.options || []).map(function () { return null; });

    /* Auto-select ONLY an option that offers no actual choice. This used to
       pre-fill every option from the first available variant, so the dialog
       opened with a size already chosen and the button live at "Add to Cart" —
       a shopper could quick-add twice and buy XS, or XXS on the youth products,
       without ever picking a size. The markup already ships the submit disabled
       and labelled "Select options"; this restores that. */
    (product.options || []).forEach(function (_opt, i) {
      const values = Array.from(new Set(
        product.variants
          .filter(function (v) { return v.available; })
          .map(function (v) { return v['option' + (i + 1)]; })
      )).filter(function (v) { return v != null && v !== ''; });
      if (values.length === 1) quickAddState.selected[i] = values[0];
    });

    const imgEl = quickAddModal.querySelector('[data-quick-add-image]');
    const title = quickAddModal.querySelector('[data-quick-add-title]');
    const category = quickAddModal.querySelector('[data-quick-add-category]');
    const optionsContainer = quickAddModal.querySelector('[data-quick-add-options]');
    const links = quickAddModal.querySelectorAll('[data-quick-add-link]');
    const errorEl = quickAddModal.querySelector('[data-quick-add-error]');
    const qtyInput = quickAddModal.querySelector('[data-qty-input]');

    // Set single product image (server-side square crop strips any white margins)
    if (imgEl) {
      const firstSrc = product.featured_image || (product.images && product.images[0]) || '';
      let url = typeof firstSrc === 'string' ? firstSrc : '';
      if (url.indexOf('//') === 0) url = 'https:' + url;
      if (url) {
        const sep = url.indexOf('?') > -1 ? '&' : '?';
        imgEl.src = url + sep + 'width=900&height=900&crop=center';
      } else {
        imgEl.removeAttribute('src');
      }
      imgEl.alt = product.title;
    }

    // Reset quantity
    quickAddState.qty = 1;
    if (qtyInput) qtyInput.value = '1';

    if (title) title.textContent = product.title;
    if (category) category.textContent = product.type || (product.tags && product.tags[0]) || '';
    links.forEach(function (link) {
      link.setAttribute('href', '/products/' + product.handle);
    });
    if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }

    /* Pre-order state: name the date and say Pre-Order rather than Add to Cart,
       so the dialog makes the same promise the PDP does. */
    const shipsEl = quickAddModal.querySelector('[data-quick-add-ships]');
    if (shipsEl) {
      shipsEl.textContent = quickAddState.ships || '';
      shipsEl.hidden = !quickAddState.ships;
    }
    // Render option rows
    optionsContainer.innerHTML = '';
    (product.options || []).forEach(function (opt, idx) {
      const optionName = typeof opt === 'string' ? opt : opt.name;
      let optionValues = typeof opt === 'string'
        ? Array.from(new Set(product.variants.map(function (v) { return v['option' + (idx + 1)]; })))
        : (opt.values || []);
      if (String(optionName).toLowerCase().trim() === 'size') {
        optionValues = unvxtSortSizes(optionValues);
      }

      const row = document.createElement('div');
      row.className = 'quick-add__option-row';
      row.setAttribute('data-option-index', String(idx));

      const isColor = isColorOption(optionName);

      const label = document.createElement('div');
      label.className = 'quick-add__option-label';
      label.innerHTML = '<span>' + escapeHtml(optionName) + '</span>' +
        '<span class="quick-add__option-label-selected" data-selected-for="' + idx + '"></span>';
      row.appendChild(label);

      const valuesEl = document.createElement('div');
      valuesEl.className = 'quick-add__option-values';

      optionValues.forEach(function (val) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'quick-add__opt-btn' + (isColor ? ' quick-add__opt-btn--swatch' : '');
        btn.setAttribute('data-option-index', String(idx));
        btn.setAttribute('data-option-value', val);
        btn.setAttribute('aria-label', optionName + ': ' + val);
        if (isColor) {
          const variantImg = findVariantImage(product, idx, val);
          if (variantImg) {
            btn.style.backgroundImage = 'url("' + variantImg + '")';
            btn.style.backgroundSize = 'cover';
            btn.style.backgroundPosition = 'center';
            btn.classList.add('quick-add__opt-btn--swatch-image');
          } else {
            btn.style.background = colorToSwatch(val);
          }
          btn.title = val;
        } else {
          btn.textContent = val;
        }
        btn.addEventListener('click', function () {
          if (btn.classList.contains('is-sold-out')) return;
          quickAddState.selected[idx] = val;
          quickAddUpdateUI();
        });
        valuesEl.appendChild(btn);
      });

      row.appendChild(valuesEl);
      optionsContainer.appendChild(row);
    });

    quickAddUpdateUI();
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Canonical size run. Shopify returns option values in CREATION order, so a
     size added later (XXS, after a youth run was bolted onto an adult product)
     sorts after XL. The PDP sorts these in Liquid; the quick-add dialog builds
     its own rows from product.js and needs the same order or the two surfaces
     disagree about the same product. */
  const UNVXT_SIZE_ORDER = ['XXS','XS','S','M','L','XL','XXL','XXXL'];
  function unvxtSortSizes(values) {
    const known = values.filter(function (v) { return UNVXT_SIZE_ORDER.indexOf(String(v).toUpperCase().trim()) > -1; });
    const rest = values.filter(function (v) { return UNVXT_SIZE_ORDER.indexOf(String(v).toUpperCase().trim()) === -1; });
    known.sort(function (a, b) {
      return UNVXT_SIZE_ORDER.indexOf(String(a).toUpperCase().trim()) -
             UNVXT_SIZE_ORDER.indexOf(String(b).toUpperCase().trim());
    });
    return known.concat(rest);
  }

  function quickAddOpenForProduct(productUrl, ships) {
    if (!quickAddModal) return;
    /* The FOURTH add-to-cart path. The buy form, the card's direct add and the
       set module all attach properties[Ships]; this one did not, so every
       pre-order added from a collection grid — which is all of them, since a
       two-option product always opens this dialog — reached the order with no
       ship date. */
    quickAddState.ships = ships || '';
    if (quickAddState.productCache[productUrl]) {
      quickAddRender(quickAddState.productCache[productUrl]);
      quickAddOpen();
      return;
    }
    const jsonUrl = productUrl.split('?')[0].replace(/\/$/, '') + '.js';
    fetch(jsonUrl, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('product_fetch_failed'); return r.json(); })
      .then(function (product) {
        quickAddState.productCache[productUrl] = product;
        quickAddRender(product);
        quickAddOpen();
      })
      .catch(function () {
        window.location.href = productUrl;
      });
  }

  if (quickAddModal) {
    quickAddModal.querySelectorAll('[data-quick-add-close]').forEach(function (el) {
      el.addEventListener('click', quickAddClose);
    });
    quickAddModal.addEventListener('click', function (e) {
      if (e.target === quickAddModal) quickAddClose();
    });
    quickAddModal.addEventListener('close', function () {
      quickAddModal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    });

    const submitBtn = quickAddModal.querySelector('[data-quick-add-submit]');
    if (submitBtn) {
      submitBtn.addEventListener('click', function () {
        const variant = quickAddFindVariant();
        const errorEl = quickAddModal.querySelector('[data-quick-add-error]');
        const submitLabel = quickAddModal.querySelector('[data-quick-add-submit-label]');
        if (!variant || !variant.available || submitBtn.disabled) return;

        submitBtn.disabled = true;
        submitBtn.classList.add('is-loading');
        if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }

        const qtyToAdd = Math.max(1, parseInt(quickAddState.qty, 10) || 1);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(
            quickAddState.ships
              ? { id: variant.id, quantity: qtyToAdd, properties: { Ships: quickAddState.ships } }
              : { id: variant.id, quantity: qtyToAdd }
          )
        })
          .then(function (r) {
            if (!r.ok) return r.json().then(function (err) { throw err; });
            return r.json();
          })
          .then(function () {
            refreshHeaderCartCount();
            submitBtn.classList.remove('is-loading');
            submitBtn.classList.add('is-added');
            submitLabel.textContent = 'Added ✓';
            setTimeout(function () {
              quickAddClose();
              submitBtn.classList.remove('is-added');
              submitBtn.disabled = false;
              openCartDrawer();
            }, 900);
          })
          .catch(function (err) {
            submitBtn.classList.remove('is-loading');
            submitBtn.disabled = false;
            if (errorEl) {
              errorEl.textContent = (err && err.description) || 'Could not add to cart. Please try again.';
              errorEl.hidden = false;
            }
          });
      });
    }

    // Quantity stepper
    const qtyInput = quickAddModal.querySelector('[data-qty-input]');
    const qtyDown = quickAddModal.querySelector('[data-qty-down]');
    const qtyUp = quickAddModal.querySelector('[data-qty-up]');
    function setQty(n) {
      const next = Math.min(QUICK_ADD_MAX_QTY, Math.max(1, n));
      quickAddState.qty = next;
      if (qtyInput) qtyInput.value = String(next);
      if (qtyDown) qtyDown.disabled = next <= 1;
      if (qtyUp) qtyUp.disabled = next >= QUICK_ADD_MAX_QTY;
    }
    if (qtyDown) qtyDown.addEventListener('click', function () { setQty(quickAddState.qty - 1); });
    if (qtyUp) qtyUp.addEventListener('click', function () { setQty(quickAddState.qty + 1); });
    setQty(1);

    // Drag-to-dismiss on mobile
    const handleEl = quickAddModal.querySelector('[data-quick-add-handle]');
    const mediaEl = quickAddModal.querySelector('[data-quick-add-media]');
    const detailsEl = quickAddModal.querySelector('[data-quick-add-details]');
    if (handleEl) {
      let dragActive = false;
      let dragStartY = 0;
      let dragLastY = 0;
      let dragLastT = 0;
      let dragVelocity = 0;
      let dragCurrent = 0;
      let dragRAF = false;

      function isMobile() { return window.matchMedia('(max-width: 767px)').matches; }

      function onPointerDown(e) {
        if (!isMobile()) return;
        // Only allow drag-to-dismiss from the handle or the media area (and only when details are at top)
        const fromHandle = e.target.closest('[data-quick-add-handle]');
        const fromMedia = e.target.closest('[data-quick-add-media]');
        if (!fromHandle && !fromMedia) return;
        if (detailsEl && detailsEl.scrollTop > 0) return;
        dragActive = true;
        dragStartY = e.clientY;
        dragLastY = e.clientY;
        dragLastT = performance.now();
        dragVelocity = 0;
        dragCurrent = 0;
        quickAddModal.classList.add('is-dragging');
        quickAddModal.style.willChange = 'transform';
      }

      function onPointerMove(e) {
        if (!dragActive) return;
        const dy = e.clientY - dragStartY;
        if (dy <= 0) {
          dragCurrent = 0;
        } else {
          dragCurrent = dy;
          const now = performance.now();
          const dt = now - dragLastT;
          if (dt > 0) dragVelocity = (e.clientY - dragLastY) / dt;
          dragLastY = e.clientY;
          dragLastT = now;
        }
        if (dragRAF) return;
        dragRAF = true;
        requestAnimationFrame(function () {
          quickAddModal.style.transform = 'translate3d(0,' + dragCurrent + 'px,0)';
          dragRAF = false;
        });
      }

      function onPointerUp() {
        if (!dragActive) return;
        dragActive = false;
        quickAddModal.classList.remove('is-dragging');
        const dismiss = dragCurrent > 100 || dragVelocity > 0.5;
        if (dismiss) {
          quickAddModal.style.transform = 'translate3d(0,100%,0)';
          setTimeout(function () {
            quickAddModal.style.willChange = '';
            quickAddClose();
          }, 220);
        } else {
          quickAddModal.style.transform = '';
          quickAddModal.style.willChange = '';
        }
      }

      quickAddModal.addEventListener('pointerdown', onPointerDown, { passive: true });
      quickAddModal.addEventListener('pointermove', onPointerMove, { passive: true });
      quickAddModal.addEventListener('pointerup', onPointerUp, { passive: true });
      quickAddModal.addEventListener('pointercancel', onPointerUp, { passive: true });
    }
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-product-card-atc]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    if (btn.disabled) return;

    const hasOptions = btn.getAttribute('data-has-options') === 'true';
    const productUrl = btn.getAttribute('data-product-url');
    const variantId = btn.getAttribute('data-variant-id');

    if (hasOptions) {
      if (productUrl) quickAddOpenForProduct(productUrl, btn.getAttribute('data-preorder-ships'));
      return;
    }

    if (!variantId) return;

    btn.disabled = true;
    /* Mirror the PDP form's line item property. Without this the SAME product
       produces different order data depending on whether it was added from its
       page or from a grid card — and the card path is the one that would ship
       with no date attached. */
    const payload = { id: variantId, quantity: 1 };
    const cardShips = btn.getAttribute('data-preorder-ships');
    if (cardShips) payload.properties = { Ships: cardShips };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add_failed');
        return r.json();
      })
      .then(function () {
        btn.classList.add('is-added');
        refreshHeaderCartCount();
        openCartDrawer();
        setTimeout(function () {
          btn.classList.remove('is-added');
          btn.disabled = false;
        }, 1400);
      })
      .catch(function () {
        btn.disabled = false;
        if (productUrl) window.location.href = productUrl;
      });
  });

  /* ============================================================
     PDP recommendations — tabs, and adding a set in one request
     ============================================================ */
  /* The compact set teaser in the buy panel links down to the full module.
     Both are rendered from the same resolver, so where one exists the other
     normally does — but the module is additionally gated by a section setting
     the buy panel cannot read. Drop the teaser rather than leave a link that
     scrolls nowhere. Deliberately outside the [data-pdp-recs] loop below: that
     loop does not run at all when the section is absent, which is exactly the
     case this needs to handle. */
  (function () {
    const setMini = document.querySelector('[data-set-mini]');
    if (!setMini) return;
    const target = document.querySelector('[data-pdp-set]');
    if (!target) {
      setMini.remove();
      return;
    }
    setMini.addEventListener('click', function (e) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  })();

  document.querySelectorAll('[data-pdp-recs]').forEach(function (recs) {
    /* Tabs. A separate controller from the homepage .nano-carousel one on
       purpose — that one is missing aria-controls, roving tabindex and arrow
       keys, and generalising it would risk a live regression on the homepage. */
    const tabs = Array.prototype.slice.call(recs.querySelectorAll('[role="tab"]'));
    const panels = Array.prototype.slice.call(recs.querySelectorAll('[role="tabpanel"]'));

    function selectTab(index, focus) {
      tabs.forEach(function (t, i) {
        const isActive = i === index;
        t.classList.toggle('is-active', isActive);
        t.setAttribute('aria-selected', isActive ? 'true' : 'false');
        t.setAttribute('tabindex', isActive ? '0' : '-1');
      });
      panels.forEach(function (p, i) {
        const isActive = i === index;
        p.classList.toggle('is-active', isActive);
        p.hidden = !isActive;
      });
      if (focus && tabs[index]) tabs[index].focus();
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { selectTab(i, false); });
      tab.addEventListener('keydown', function (e) {
        let next = null;
        if (e.key === 'ArrowRight') next = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = tabs.length - 1;
        if (next === null) return;
        e.preventDefault();
        selectTab(next, true);
      });
    });

    /* The set pair. The shopper has already chosen a size for the product they
       are looking at, so only the partner's size is asked for here; the current
       variant is read from the buy form, which main.js keeps in sync. */
    const setModule = recs.querySelector('[data-pdp-set]');
    if (!setModule) return;

    const setBtn = setModule.querySelector('[data-set-add]');
    const setLabel = setModule.querySelector('[data-set-add-label]');
    const setError = setModule.querySelector('[data-set-error]');
    const sizeRow = setModule.querySelector('.pdp-set__size-row');
    if (!setBtn || !sizeRow) return;

    /* Run-aware pricing. The module renders server-side for the run the page
       loads with; this re-prices it and rebuilds the size row when the buy panel
       switches, so a shopper on Youth never sees an adult set total. Products
       without a Sizing option emit no blob and none of this runs. */
    let setData = null;
    const setDataEl = setModule.querySelector('[data-set-data]');
    if (setDataEl) {
      try { setData = JSON.parse(setDataEl.textContent); } catch (e) { setData = null; }
    }

    function applyRun(run) {
      if (!setData || !run) return;
      const key = Object.keys(setData.runs || {}).find(function (k) {
        return k.toLowerCase().trim() === String(run).toLowerCase().trim();
      });
      if (!key) return;
      const r = setData.runs[key];

      const parts = setModule.querySelector('.pdp-set__price-parts');
      const was = setModule.querySelector('.pdp-set__price-was');
      const total = setModule.querySelector('.pdp-set__price-total');
      if (parts) parts.textContent = r.parts;
      if (was) was.textContent = r.totalM;
      if (total) total.textContent = r.saving > 0 ? r.payM : r.totalM;

      if (setLabel) {
        setLabel.textContent = setLabel.textContent.replace(/—.*$/, '').trim() + ' — ' + r.payM;
      }

      /* Rebuild rather than toggle: the run decides which sizes EXIST, and one
         source of truth for that is the variant list. */
      const chosen = sizeRow.querySelector('.size-btn.is-selected[data-set-variant]');
      const chosenSize = chosen && chosen.textContent.trim();
      const inRun = (setData.variants || []).filter(function (v) {
        return String(v.run).toLowerCase().trim() === key.toLowerCase().trim();
      });
      if (inRun.length) {
        sizeRow.innerHTML = inRun.map(function (v) {
          const keep = chosenSize && v.size === chosenSize ? ' is-selected' : '';
          return v.available
            ? '<button type="button" class="size-btn' + keep + '" data-set-variant="' + v.id +
              '" aria-label="' + escapeCartHtml(v.size) + '">' + escapeCartHtml(v.size) + '</button>'
            : '<span class="size-btn is-sold-out" aria-disabled="true" role="presentation">' +
              escapeCartHtml(v.size) + '</span>';
        }).join('');
        if (!sizeRow.querySelector('.size-btn.is-selected[data-set-variant]')) {
          const first = sizeRow.querySelector('button.size-btn[data-set-variant]');
          if (first) first.classList.add('is-selected');
        }
      }

      // The meter measures the discounted total, same as the drawer will.
      if (setData.fsEnabled && setData.fsThreshold > 0) {
        const ship = setModule.querySelector('.pdp-set__ship');
        const text = setModule.querySelector('.pdp-set__ship-text');
        const fill = setModule.querySelector('.pdp-set__ship-fill');
        const gap = setData.fsThreshold - r.pay;
        if (ship) ship.classList.toggle('is-unlocked', gap <= 0);
        if (text) {
          text.innerHTML = gap > 0
            ? "You're <strong>$" + (gap / 100).toFixed(2) + '</strong> away from free shipping'
            : '\u2713 This set ships free';
        }
        if (fill) fill.style.width = Math.min(100, Math.round(r.pay * 100 / setData.fsThreshold)) + '%';
      }
    }

    document.addEventListener('unvxt:run-change', function (e) {
      applyRun(e.detail && e.detail.run);
    });

    sizeRow.addEventListener('click', function (e) {
      const btn = e.target.closest('button.size-btn[data-set-variant]');
      if (!btn) return;
      sizeRow.querySelectorAll('.size-btn').forEach(function (b) {
        b.classList.toggle('is-selected', b === btn);
      });
      if (setError) { setError.hidden = true; setError.textContent = ''; }
    });

    function showSetError(message) {
      if (!setError) return;
      setError.textContent = message;
      setError.hidden = false;
    }

    function performSetAdd() {

      const currentInput = document.querySelector('#product-form input[name="id"]');
      const currentId = currentInput && currentInput.value;
      const partnerBtn = sizeRow.querySelector('.size-btn.is-selected[data-set-variant]');
      const partnerId = partnerBtn && partnerBtn.getAttribute('data-set-variant');

      if (!currentId) { showSetError('Choose a size above first.'); return; }
      if (!partnerId) { showSetError('Choose a size for the matching piece.'); return; }

      const defaultLabel = setLabel ? setLabel.textContent : '';
      setBtn.disabled = true;
      setBtn.classList.add('is-loading');
      if (setError) { setError.hidden = true; setError.textContent = ''; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [
            { id: currentId, quantity: 1 },
            { id: partnerId, quantity: 1 }
          ].map(function (line) {
            /* The other two add paths attach this; without it a set bought here
               reaches the packing slip with no ship date on either line. */
            return setData && setData.ships
              ? Object.assign({}, line, { properties: { Ships: setData.ships } })
              : line;
          })
        })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (err) { throw err; });
          return r.json();
        })
        .then(function () {
          refreshHeaderCartCount();
          setBtn.classList.remove('is-loading');
          setBtn.classList.add('is-added');
          if (setLabel) setLabel.textContent = 'Set added \u2713';
          openCartDrawer();
          setTimeout(function () {
            setBtn.classList.remove('is-added');
            setBtn.disabled = false;
            if (setLabel) setLabel.textContent = defaultLabel;
          }, 1400);
        })
        .catch(function (err) {
          /* Shopify rejects the WHOLE items array if either line is short, so a
             failure here means neither product was added — say so rather than
             leaving the shopper guessing which half landed. */
          setBtn.classList.remove('is-loading');
          setBtn.disabled = false;
          showSetError((err && err.description) || 'Could not add the set. Try adding each piece on its own.');
        });
    }

    /* Size confirmation before the set is added. Both halves arrive
       pre-selected — the buy panel on selected_or_first_available_variant, the
       partner row on its first size — so a shopper who scrolls past the buy
       panel could buy XS + XS without ever being asked, which produced real
       wrong-size orders.

       The dialog's rows are CLONED from the live controls rather than rebuilt.
       Those rows are already run-aware and already carry sold-out state, and
       applyRun() rewrites the partner row when Adult/Youth changes; a second
       copy of that logic here would drift out of step. */
    const confirmEl = setModule.querySelector('[data-set-confirm]');
    const confirmOwn = confirmEl && confirmEl.querySelector('[data-set-confirm-own]');
    const confirmPartner = confirmEl && confirmEl.querySelector('[data-set-confirm-partner]');
    const confirmRun = confirmEl && confirmEl.querySelector('[data-set-confirm-run]');
    const confirmError = confirmEl && confirmEl.querySelector('[data-set-confirm-error]');
    const confirmSubmit = confirmEl && confirmEl.querySelector('[data-set-confirm-submit]');
    const confirmSubmitLabel = confirmEl && confirmEl.querySelector('[data-set-confirm-submit-label]');
    const confirmRunRow = confirmEl && confirmEl.querySelector('[data-set-confirm-run-row]');

    /* Re-queried, never cached: the buy panel rebuilds its size row when the run
       changes, and applyRun() rewrites the partner row, so a held reference can
       point at detached nodes. */
    function ownSourceRow() {
      return document.querySelector('.pdp-buy__option-row--size .pdp-buy__option-values');
    }
    function runSourceRow() {
      return document.querySelector('.pdp-buy__option-row[data-sizing-row] .pdp-buy__option-values');
    }

    function cloneSizeButtons(sourceRow, target, valueAttr, sourceAttr) {
      if (!target) return 0;
      target.innerHTML = '';
      if (!sourceRow) return 0;
      let count = 0;
      Array.prototype.forEach.call(sourceRow.children, function (node) {
        const label = node.textContent.trim();
        if (!label) return;
        if (node.classList.contains('is-sold-out')) {
          const span = document.createElement('span');
          span.className = 'size-btn is-sold-out';
          span.setAttribute('aria-disabled', 'true');
          span.setAttribute('role', 'presentation');
          span.textContent = label;
          target.appendChild(span);
          return;
        }
        const value = node.getAttribute(sourceAttr);
        if (!value) return;
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'size-btn' + (node.classList.contains('is-selected') ? ' is-selected' : '');
        btn.setAttribute(valueAttr, value);
        btn.textContent = label;
        target.appendChild(btn);
        count += 1;
      });
      return count;
    }

    function confirmMessage(text) {
      if (!confirmError) return;
      confirmError.textContent = text || '';
      confirmError.hidden = !text;
    }

    /* Mirror the page into the dialog: both size rows, the Adult/Youth row, and
       the button label (applyRun rewrites it with that run's price). Hide the
       run row unless there is a real choice. */
    function mirrorRows() {
      cloneSizeButtons(ownSourceRow(), confirmOwn, 'data-own-value', 'data-option-value');
      cloneSizeButtons(sizeRow, confirmPartner, 'data-partner-variant', 'data-set-variant');
      const runCount = cloneSizeButtons(runSourceRow(), confirmRunRow, 'data-run-value', 'data-option-value');
      if (confirmRun) confirmRun.hidden = runCount < 2;
      if (confirmSubmitLabel && setLabel) confirmSubmitLabel.textContent = setLabel.textContent;
    }

    function openConfirm() {
      confirmMessage('');
      mirrorRows();

      if (typeof confirmEl.showModal === 'function') confirmEl.showModal();
      else confirmEl.setAttribute('open', '');

      const focusTarget = confirmEl.querySelector('.size-btn.is-selected') ||
        confirmEl.querySelector('button.size-btn') || confirmSubmit;
      if (focusTarget && focusTarget.focus) focusTarget.focus();
    }

    function closeConfirm() {
      if (!confirmEl) return;
      if (typeof confirmEl.close === 'function') confirmEl.close();
      else confirmEl.removeAttribute('open');
      if (setBtn.focus) setBtn.focus();
    }

    if (confirmEl) {
      confirmEl.addEventListener('click', function (e) {
        // A <dialog> reports backdrop clicks as hits on the dialog itself.
        if (e.target === confirmEl) { closeConfirm(); return; }
        if (e.target.closest('[data-set-confirm-close]')) { closeConfirm(); return; }
        const picked = e.target.closest('button.size-btn');
        if (!picked || !picked.parentElement) return;

        /* Adult/Youth: drive the page's own control rather than re-implementing
           the switch. That rebuilds the buy panel's sizes, fires unvxt:run-change
           so applyRun() rebuilds the partner row and re-prices, and then the
           dialog re-mirrors whatever the page now says. */
        if (picked.hasAttribute('data-run-value')) {
          const runValue = picked.getAttribute('data-run-value');
          const row = runSourceRow();
          const pageRunBtn = row && Array.prototype.slice
            .call(row.querySelectorAll('button.size-btn[data-option-value]'))
            .find(function (b) { return b.getAttribute('data-option-value') === runValue; });
          if (pageRunBtn && !pageRunBtn.classList.contains('is-selected')) {
            pageRunBtn.click();
            requestAnimationFrame(mirrorRows);
          }
          confirmMessage('');
          return;
        }

        picked.parentElement.querySelectorAll('.size-btn').forEach(function (b) {
          b.classList.toggle('is-selected', b === picked);
        });
        confirmMessage('');
      });

      // Esc fires 'cancel' rather than a click; hand focus back the same way.
      confirmEl.addEventListener('cancel', function () {
        if (setBtn.focus) setBtn.focus();
      });

      /* Close on Esc explicitly. A <dialog> opened with showModal() is supposed
         to do this itself, but it did not fire reliably in testing, and a modal
         a shopper cannot dismiss with the keyboard is a trap. */
      confirmEl.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape' && e.key !== 'Esc') return;
        e.preventDefault();
        closeConfirm();
      });

      if (confirmSubmit) {
        confirmSubmit.addEventListener('click', function () {
          const ownPick = confirmOwn && confirmOwn.querySelector('button.size-btn.is-selected[data-own-value]');
          const partnerPick = confirmPartner && confirmPartner.querySelector('button.size-btn.is-selected[data-partner-variant]');
          const ownNeeded = confirmOwn && confirmOwn.querySelector('button.size-btn[data-own-value]');
          const partnerNeeded = confirmPartner && confirmPartner.querySelector('button.size-btn[data-partner-variant]');

          if ((ownNeeded && !ownPick) || (partnerNeeded && !partnerPick)) {
            confirmMessage('Pick a size for both pieces.');
            return;
          }

          /* Apply through the page's own controls so every existing handler runs
             — hidden variant id, set pricing, the shipping meter — rather than
             resolving variants a second way in here. */
          const ownSource = ownSourceRow();
          if (ownPick && ownSource) {
            const value = ownPick.getAttribute('data-own-value');
            const pageBtn = Array.prototype.slice
              .call(ownSource.querySelectorAll('button.size-btn[data-option-value]'))
              .find(function (b) { return b.getAttribute('data-option-value') === value; });
            if (pageBtn && !pageBtn.classList.contains('is-selected')) pageBtn.click();
          }
          if (partnerPick) {
            const vid = partnerPick.getAttribute('data-partner-variant');
            const pageBtn = sizeRow.querySelector('button.size-btn[data-set-variant="' + vid + '"]');
            if (pageBtn && !pageBtn.classList.contains('is-selected')) pageBtn.click();
          }

          closeConfirm();
          // One frame, in case the buy panel updates the hidden input async.
          requestAnimationFrame(function () { performSetAdd(); });
        });
      }
    }

    setBtn.addEventListener('click', function () {
      if (setBtn.disabled) return;
      if (confirmEl) { openConfirm(); return; }
      performSetAdd();
    });
  });

})();
